/*
 * サブシステム名：マスタ管理
 * 機能名：取引先マスタ登録
 */
import flowMixin from '@/mixins/flowMixins'
import validators from '@/rahmen/validators'
import filter from '@/rahmen/utils/filters'

import { mapGetters } from 'vuex'
import message from '@/ddv2.library/messages'

import header from '@/ddv2.library/header'

import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'

const DdCheckbox = () => import('@/components/DdCheckbox')
const DdCodeTextBox = () => import('@/components/DdCodeTextBox')
const DdDateBox = () => import('@/components/DdDateBox')
const DdDropDown = () => import('@/components/DdDropDown')
const DdEditCommonBar = () => import('@/components/DdEditCommonBar')
const DdIconButton = () => import('@/components/DdIconButton')
const DdIconButtonWithTooltip = () => import('@/components/DdIconButtonWithTooltip')
const DdNumericBox = () => import('@/components/DdNumericBox')
const DdRadioButton = () => import('@/components/DdRadioButton')
const DdSectionTitle = () => import('@/components/DdSectionTitle')
const DdSubHeader = () => import('@/components/DdSubHeader')
const DdSwitch = () => import('@/components/DdSwitch')
const DdTextBox = () => import('@/components/DdTextBox')
const DdTorihikisakiKingakuDialog = () => import('@/components/DdTorihikisakiKingakuDialog')

const DdArrowHeader = () => import('@/components/DdArrowHeader')
const DdArrowHeaderWithSwitch = () => import('@/components/DdArrowHeaderWithSwitch')
const DdDataTable = () => import('@/components/DdDataTable')
const DdDefaultButton = () => import('@/components/DdDefaultButton')
const DdSubTitle = () => import('@/components/DdSubTitle')
const DdSubTitleWithSwitch = () => import('@/components/DdSubTitleWithSwitch')
const DdSubHeaderWithSwitch = () => import('@/components/DdSubHeaderWithSwitch')

export default {
  name: 'MstTorihikisakiEdit',
  mixins: [flowMixin],
  components: {
    DdCustomButton,
    DdTransparentButton,

    DdCheckbox,
    DdCodeTextBox,
    DdDateBox,
    DdDropDown,
    DdEditCommonBar,
    DdIconButton,
    DdIconButtonWithTooltip,
    DdNumericBox,
    DdRadioButton,
    DdSectionTitle,
    DdSubHeader,
    DdSwitch,
    DdTextBox,
    DdTorihikisakiKingakuDialog,

    DdArrowHeader,
    DdArrowHeaderWithSwitch,
    DdDataTable,
    DdDefaultButton,
    DdSubHeaderWithSwitch,
    DdSubTitle,
    DdSubTitleWithSwitch
  },
  data: () => ({
    id: 0,
    copyMode: false,
    tokuiKingakuDialog: false,
    shiireKingakuDialog: false,
    hacchuKingakuDialog: false,
    tab: 'tab1',
    rec: {
      mstTorihikisaki: {},
      torihikisakiKihonAddress: {},
      torihikisakiAddAddress1: {},
      torihikisakiAddAddress2: {},
      mstTokuisaki: {},
      tokuiKingaku: {},
      mstSeikyusaki: {},
      seikyushoHassosakiAddress: {},
      seikyushoRenrakusakiAddress: {},
      seikyusakiList: [],
      mstNyukinsaki: {},
      nyukinRenrakusakiAddress: {},
      nyukinsakiList: [],
      mstShiiresaki: {},
      shiireKingaku: {},
      mstHacchusaki: {},
      hacchuKingaku: {},
      mstShiharaisaki: {},
      shiharaitsuchiHassosakiAddress: {},
      shiharaitsuchiRenrakusakiAddress: {},
      shiharaisakiList: []
    },
    address1UseFlg: false,
    address2UseFlg: false,
    tokuisakiFlg: false,
    ikkatsuSeikyusakiFlg: false,
    // otherSeikyushoHassosakiFlg: false,
    seikyushoHassosakiKbn: '0',
    // otherSeikyushoRenrakusakiFlg: false,
    seikyushoRenrakusakiKbn: '0',
    tokuisakiKobetsuSeikyumeisaishoFlg: false,
    ikkatsuNyukinsakiFlg: false,
    // otherNyukinRenrakusakiFlg: false,
    nyukinRenrakusakiKbn: '0',
    shiiresakiFlg: false,
    shiiresakiKobetsuShiharaimeisaishoFlg: false,
    hacchusakiFlg: false,
    hacchusakiSharyoKanriFlg: false,
    hacchusakiKobetsuShiharaimeisaishoFlg: false,
    ikkatsuShiharaisakiFlg: false,
    // otherShiharaitsuchiHassosakiFlg: false,
    shiharaitsuchiHassosakiKbn: '0',
    // otherShiharaitsuchiRenrakusakiFlg: false,
    shiharaitsuchiRenrakusakiKbn: '0',
    shiharaiTorihikisakiCd: '',
    add1AddressSeishikiNm: '',
    add1AddressNm: '',
    add2AddressSeishikiNm: '',
    add2AddressNm: '',
    seikyuHassoAddressSeishikiNm: '',
    seikyuHassoAddressNm: '',
    seikyuRenrakuAddressSeishikiNm: '',
    seikyuRenrakuAddressNm: '',
    nyukinRenrakuAddressSeishikiNm: '',
    nyukinRenrakuAddressNm: '',
    shiharaiHassoAddressSeishikiNm: '',
    shiharaiHassoAddressNm: '',
    shiharaiRenrakuAddressSeishikiNm: '',
    shiharaiRenrakuAddressNm: '',
    seikyuTogetsuKijunHandanKbn: '01',
    shiharaiTogetsuKijunHandanKbn: '01',
    shiharaiKozaSbt: '1',
    kingaku: {},
    invalidMessages: {},
    colorDialog: false,
    chipColorTmp: '',
    headersTorihikisakiList: header.mstTorihikisakiHeaders,
    headersTantoshaList: header.mstJininHeaders,
    headersHacchakuchiList: header.mstHacchakuchiHeaders,
    headersHinmeiList: header.mstHinmeiHeaders,
    seikyuHeaders: [
      { text: '取引先コード', value: 'torihikisakiCd' },
      { text: '取引先名称', value: 'torihikisakiNm' },
      { text: '取引先正式名称', value: 'torihikisakiSeishikiNm' },
      { text: '取引先名称カナ', value: 'torihikisakiNmKana' },
      { text: '取引先分類種別１', value: 'torihikisakiBunruiKbn1Nm' },
      { text: '取引先分類種別２', value: 'torihikisakiBunruiKbn2Nm' },
      { text: '取引先分類種別３', value: 'torihikisakiBunruiKbn3Nm' },
      { text: '地域種別', value: 'chiikiKbnNm' },
      { text: '地区種別', value: 'chikuKbnNm' },
      { text: '主たる発着地', value: 'hacchakuchiNm' },
      { text: '主たる品名', value: 'hinmeiNm' },
      { text: '社内主担当者', value: 'shanaiTantoshaNm' },
      { text: '運賃計算取引先名称', value: 'unchinKeisanTorihikisakiNm' },
      { text: '運賃端数計算区分', value: 'unchinHasuKeisanKbnNm' },
      { text: '運賃計算方法区分', value: 'unchinKeisanKbnNm' },
      { text: '割増時間単価', value: 'warimashiJikanTankaDisp', align: 'end' },
      { text: '割増距離単価', value: 'warimashiKyoriTankaDisp', align: 'end' },
      { text: '割増係数率', value: 'warimashiKeisuDisp', align: 'end' },
      { text: '割増燃料係数', value: 'warimashiNenryoKeisuDisp', align: 'end' },
      { text: '計上日区分', value: 'keijobiKbnNm' },
      { text: '数量計上日区分', value: 'suryoKeijoKbnNm' },
      { text: '請求計算ルール利用区分', value: 'seikyuKeisanRuleKbnNm' }
    ],
    nyukinHeaders: [
      { text: '取引先コード', value: 'torihikisakiCd' },
      { text: '取引先名称', value: 'torihikisakiNm' },
      { text: '取引先正式名称', value: 'torihikisakiSeishikiNm' },
      { text: '取引先名称カナ', value: 'torihikisakiNmKana' },
      { text: '取引先分類種別１', value: 'torihikisakiBunruiKubun1Nm' },
      { text: '取引先分類種別２', value: 'torihikisakiBunruiKubun2Nm' },
      { text: '取引先分類種別３', value: 'torihikisakiBunruiKubun3Nm' },
      { text: '地域種別', value: 'chiikiKubunNm' },
      { text: '地区種別', value: 'chikuKubunNm' }
    ],
    shiharaiHeaders: [
      { text: '取引先コード', value: 'torihikisakiCd' },
      { text: '取引先名称', value: 'torihikisakiNm' },
      { text: '取引先正式名称', value: 'torihikisakiSeishikiNm' },
      { text: '取引先名称カナ', value: 'torihikisakiNmKana' },
      { text: '取引先分類種別１', value: 'torihikisakiBunruiKbn1Nm' },
      { text: '取引先分類種別２', value: 'torihikisakiBunruiKbn2Nm' },
      { text: '取引先分類種別３', value: 'torihikisakiBunruiKbn3Nm' },
      { text: '地域種別', value: 'chiikiKbnNm' },
      { text: '地区種別', value: 'chikuKbnNm' },
      { text: 'ガソリン単価', value: 'fuelTanka01Disp', align: 'end' },
      { text: 'ハイオク単価', value: 'fuelTanka02Disp', align: 'end' },
      { text: '軽油単価', value: 'fuelTanka03Disp', align: 'end' },
      { text: 'LPガス単価', value: 'fuelTanka04Disp', align: 'end' },
      { text: '天然ガス単価', value: 'fuelTanka05Disp', align: 'end' },
      { text: 'その他燃料単価', value: 'fuelTanka99Disp', align: 'end' },
      { text: '運賃計算取引先名称', value: 'unchinKeisanTorihikisakiNm' },
      { text: '運賃端数計算区分', value: 'unchinHasuKeisanKbnNm' },
      { text: '運賃計算方法区分', value: 'unchinKeisanKbnNm' },
      { text: '割増時間単価', value: 'warimashiJikanTankaDisp', align: 'end' },
      { text: '割増距離単価', value: 'warimashiKyoriTankaDisp', align: 'end' },
      { text: '割増係数率', value: 'warimashiKeisuDisp', align: 'end' },
      { text: '仕入計算ルール利用区分', value: 'shiireKeisanRuleKbnNm' },
      { text: '発注計算ルール利用区分', value: 'hacchusakiKeisanRuleKbnNm' }
    ],
    // 表示制御
    isAnkerLinkDisp: false,
    // 更新モード 0:新規、1:照会、2:更新
    modeOfEdit: 2,
    // 権限情報 0:読取、1:削除不可、2:フル
    modeKengen: 2
  }),
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      jininList: 'DDMasters/vwCMstEigyoshoJininList',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      hacchakuchiList: 'DDMasters/mstHacchakuchi',
      hinmeiList: 'DDMasters/mstHinmei',
      kubunList: 'DDMasters/msysKubun',
      shubetsuList: 'DDMasters/mstShubetsu',
      kihonJohoList: 'DDMasters/mstKihonJoho',
      nyukinsakiList: 'DDMasters/vwCMstTorihikisakiGetNyukinsaki',
      shiharaisakiList: 'DDMasters/vwCMstTorihikisakiGetShiharaisaki',
      seikyusakiList: 'DDMasters/vwCMstTorihikisakiGetSeikyusaki'
    }),
    torihikisakiBunruiKbn1List () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SBT002')
    },
    torihikisakiBunruiKbn2List () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SBT003')
    },
    torihikisakiBunruiKbn3List () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SBT004')
    },
    chiikiSbtList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVI001')
    },
    chikuSbtList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVI002')
    },
    seikyuKeisanRuleKbnList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'KBN004')
    },
    nyukinKbnList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'SFF061')
    },
    hasuKeisanKbnList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'SFF060')
    },
    shohizeiKeisanUnitKbnList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'SFF072')
    },
    seikyushoShukeiUnitKbnList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'SFF096')
    },
    unchinKeisanKbnList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'SFF055')
    },
    keijobiKbnList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'SFF084')
    },
    suryoKeijoKbnList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'SFF101')
    },
    seikyushoLayoutKbnList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'SFF065')
    },
    seikyumeisaishoLayoutKbnList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'SFF107')
    },
    shiharaiLayoutKbnList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'KBN007')
    },
    shiharaimeisaiLayoutKbnList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'KBN028')
    },
    shiireKeisanRuleKbnList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'KBN006')
    },
    hacchuKeisanRuleKbnList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'KBN005')
    },
    shiharaiKbnList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'SFF062')
    },
    shiharaiShukeiUnitKbnList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'KBN008')
    },
    kazeiKbnList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'KBN001')
    },
    filteredTogettsuKijunHandanKbnList () {
      return this.kubunList.filter((kbn) => kbn.kbnShuruiCd === 'SFF064')
        .map((elem) => {
          elem.code = elem.code.trim()
          return elem
        })
    },
    filteredKozaSbtList () {
      return this.kubunList.filter((kbn) => kbn.kbnShuruiCd === 'SFF070')
        .map((elem) => {
          elem.code = elem.code.trim()
          return elem
        })
    },
    filteredTorihikisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },
    filteredNyukinsaki4ACList () {
      const target = filter.dateFormatter(new Date())
      return this.nyukinsakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },
    filteredShiharaisaki4ACList () {
      const target = filter.dateFormatter(new Date())
      return this.shiharaisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },
    filteredSeikyusaki4ACList () {
      const target = filter.dateFormatter(new Date())
      return this.seikyusakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },
    filteredShanaishuTantoshaList () {
      const target = filter.dateFormatter(new Date())
      return this.jininList.map((elem) => {
        elem.jininNm = elem.jininNmSei + (elem.jininNmMei ? ' ' + elem.jininNmMei : '')
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.jininCd > elem2.jininCd) { return 1 }
        if (elem1.jininCd === elem2.jininCd) { return 0 }
        return -1
      })
    },
    filteredHacchakuchiList () {
      const target = filter.dateFormatter(new Date())
      return this.hacchakuchiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return (elem.torihikisakiCd === null || elem.torihikisakiCd === '') && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.hacchakuchiCd > elem2.hacchakuchiCd) { return 1 }
        if (elem1.hacchakuchiCd === elem2.hacchakuchiCd) { return 0 }
        return -1
      })
    },
    filteredHinmeiList () {
      const target = filter.dateFormatter(new Date())
      return this.hinmeiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return (elem.torihikisakiCd === null || elem.torihikisakiCd === '') && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.hinmeiCd > elem2.hinmeiCd) { return 1 }
        if (elem1.hinmeiCd === elem2.hinmeiCd) { return 0 }
        return -1
      })
    },
    /*
    initializeKingaku () {
      return this.kingakuList.filter((kin) => {
        return kin.id === this.kihonJohoList.filter((kihon) => kihon.kaishaCd === '0010')[0]?.mstKingakuId
      }).length ? this.kingakuList.filter((kin) => kin.id === this.kihonJohoList.filter((kihon) => kihon.kaishaCd === '0010')[0]?.mstKingakuId)[0]
        : {
          kihonUnchinShiyoFlg: true,
          kihonUnchinTitle: '基本運賃(課税)',
          kihonUnchinShukeiKbn: '01',
          hiwayPriceShiyoFlg: true,
          hiwayPriceTitle: '時間割増金額(課税)',
          hiwayPriceShukeiKbn: '01',
          jikanWarimashiKingakuShiyoFlg: true,
          jikanWarimashiKingakuTitle: '距離割増金額(課税)',
          jikanWarimashiKingakuShukeiKbn: '01',
          kyoriWarimashiKingakuShiyoFlg: true,
          kyoriWarimashiKingakuTitle: '係数割増金額(課税)',
          kyoriWarimashiKingakuShukeiKbn: '01',
          keisuWarimashiKingakuShiyoFlg: true,
          keisuWarimashiKingakuTitle: '燃料割増金額(課税)',
          keisuWarimashiKingakuShukeiKbn: '01',
          nenryoWarimashiKingakuShiyoFlg: true,
          nenryoWarimashiKingakuTitle: '高速代(内税)',
          nenryoWarimashiKingakuShukeiKbn: '01',
          userKingakuKazei1ShiyoFlg: true,
          userKingakuKazei1Title: 'ユーザ金額(課税)１',
          userKingakuKazei1ShukeiKbn: '01',
          userKingakuKazei2ShiyoFlg: true,
          userKingakuKazei2Title: 'ユーザ金額(課税)２',
          userKingakuKazei2ShukeiKbn: '01',
          userKingakuKazei3ShiyoFlg: true,
          userKingakuKazei3Title: 'ユーザ金額(課税)３',
          userKingakuKazei3ShukeiKbn: '01',
          userKingakuKazei4ShiyoFlg: true,
          userKingakuKazei4Title: 'ユーザ金額(課税)４',
          userKingakuKazei4ShukeiKbn: '01',
          userKingakuKazei5ShiyoFlg: true,
          userKingakuKazei5Title: 'ユーザ金額(課税)５',
          userKingakuKazei5ShukeiKbn: '01',
          userKingakuKazei6ShiyoFlg: true,
          userKingakuKazei6Title: 'ユーザ金額(課税)６',
          userKingakuKazei6ShukeiKbn: '01',
          userKingakuKazei7ShiyoFlg: true,
          userKingakuKazei7Title: 'ユーザ金額(課税)７',
          userKingakuKazei7ShukeiKbn: '01',
          userKingakuKazei8ShiyoFlg: true,
          userKingakuKazei8Title: 'ユーザ金額(課税)８',
          userKingakuKazei8ShukeiKbn: '01',
          userKingakuKazei9ShiyoFlg: true,
          userKingakuKazei9Title: 'ユーザ金額(課税)９',
          userKingakuKazei9ShukeiKbn: '01',
          userKingakuKazei10ShiyoFlg: true,
          userKingakuKazei10Title: 'ユーザ金額(課税)１０',
          userKingakuKazei10ShukeiKbn: '01',
          userKingakuHikazei1ShiyoFlg: true,
          userKingakuHikazei1Title: 'ユーザ金額(非課税)１',
          userKingakuHikazei1ShukeiKbn: '01',
          userKingakuHikazei2ShiyoFlg: true,
          userKingakuHikazei2Title: 'ユーザ金額(非課税)２',
          userKingakuHikazei2ShukeiKbn: '01',
          userKingakuHikazei3ShiyoFlg: true,
          userKingakuHikazei3Title: 'ユーザ金額(非課税)３',
          userKingakuHikazei3ShukeiKbn: '01',
          userKingakuHikazei4ShiyoFlg: true,
          userKingakuHikazei4Title: 'ユーザ金額(非課税)４',
          userKingakuHikazei4ShukeiKbn: '01',
          userKingakuHikazei5ShiyoFlg: true,
          userKingakuHikazei5Title: 'ユーザ金額(非課税)５',
          userKingakuHikazei5ShukeiKbn: '01',
          userKingakuHikazei6ShiyoFlg: true,
          userKingakuHikazei6Title: 'ユーザ金額(非課税)６',
          userKingakuHikazei6ShukeiKbn: '01',
          userKingakuHikazei7ShiyoFlg: true,
          userKingakuHikazei7Title: 'ユーザ金額(非課税)７',
          userKingakuHikazei7ShukeiKbn: '01',
          userKingakuHikazei8ShiyoFlg: true,
          userKingakuHikazei8Title: 'ユーザ金額(非課税)８',
          userKingakuHikazei8ShukeiKbn: '01',
          userKingakuHikazei9ShiyoFlg: true,
          userKingakuHikazei9Title: 'ユーザ金額(非課税)９',
          userKingakuHikazei9ShukeiKbn: '01',
          userKingakuHikazei10ShiyoFlg: true,
          userKingakuHikazei10Title: 'ユーザ金額(非課税)１０',
          userKingakuHikazei10ShukeiKbn: '01',
          userKingakuUchizei1ShiyoFlg: true,
          userKingakuUchizei1Title: 'ユーザ金額(内税)１',
          userKingakuUchizei1ShukeiKbn: '01',
          userKingakuUchizei2ShiyoFlg: true,
          userKingakuUchizei2Title: 'ユーザ金額(内税)２',
          userKingakuUchizei2ShukeiKbn: '01',
          userKingakuUchizei3ShiyoFlg: true,
          userKingakuUchizei3Title: 'ユーザ金額(内税)３',
          userKingakuUchizei3ShukeiKbn: '01',
          userKingakuUchizei4ShiyoFlg: true,
          userKingakuUchizei4Title: 'ユーザ金額(内税)４',
          userKingakuUchizei4ShukeiKbn: '01',
          userKingakuUchizei5ShiyoFlg: true,
          userKingakuUchizei5Title: 'ユーザ金額(内税)５',
          userKingakuUchizei5ShukeiKbn: '01',
          userKingakuUchizei6ShiyoFlg: true,
          userKingakuUchizei6Title: 'ユーザ金額(内税)６',
          userKingakuUchizei6ShukeiKbn: '01',
          userKingakuUchizei7ShiyoFlg: true,
          userKingakuUchizei7Title: 'ユーザ金額(内税)７',
          userKingakuUchizei7ShukeiKbn: '01',
          userKingakuUchizei8ShiyoFlg: true,
          userKingakuUchizei8Title: 'ユーザ金額(内税)８',
          userKingakuUchizei8ShukeiKbn: '01',
          userKingakuUchizei9ShiyoFlg: true,
          userKingakuUchizei9Title: 'ユーザ金額(内税)９',
          userKingakuUchizei9ShukeiKbn: '01',
          userKingakuUchizei10ShiyoFlg: true,
          userKingakuUchizei10Title: 'ユーザ金額(内税)１０',
          userKingakuUchizei10ShukeiKbn: '01'
        }
    },
    */
    isAddress1Use () {
      if (!this.address1UseFlg) {
        return false
      }
      return true
    },
    isAddress2Use () {
      if (!this.address2UseFlg) {
        return false
      }
      return true
    },
    isTokuisaki () {
      if (!this.tokuisakiFlg) {
        return false
      }
      return true
    },
    isHonseikyusaki () {
      if (!(!this.ikkatsuSeikyusakiFlg && this.tokuisakiFlg)) {
        return false
      }
      return true
    },
    isIkkatsuseikyusaki () {
      if (!(this.ikkatsuSeikyusakiFlg && this.tokuisakiFlg)) {
        return false
      }
      return true
    },
    otherSeikyushoHassosakiFlg () {
      return this.seikyushoHassosakiKbn === '9'
    },
    isOtherSeikyuHassosaki () {
      if (!(!this.ikkatsuSeikyusakiFlg && this.tokuisakiFlg && this.otherSeikyushoHassosakiFlg)) {
        return false
      }
      return true
    },
    isNotOtherSeikyuHassosaki () {
      if (!(!this.ikkatsuSeikyusakiFlg && this.tokuisakiFlg && !this.otherSeikyushoHassosakiFlg)) {
        return false
      }
      return true
    },
    isOtherSeikyuRenrakusaki () {
      if (!(!this.ikkatsuSeikyusakiFlg && this.tokuisakiFlg && this.otherSeikyushoRenrakusakiFlg)) {
        return false
      }
      return true
    },
    otherSeikyushoRenrakusakiFlg () {
      return this.seikyushoRenrakusakiKbn === '9'
    },
    isNotOtherSeikyuRenrakusaki () {
      if (!(!this.ikkatsuSeikyusakiFlg && this.tokuisakiFlg && !this.otherSeikyushoRenrakusakiFlg)) {
        return false
      }
      return true
    },
    isKobetsuSeikyumeisaisho () {
      if (!(this.ikkatsuSeikyusakiFlg && this.tokuisakiFlg && this.tokuisakiKobetsuSeikyumeisaishoFlg)) {
        return false
      }
      return true
    },
    isHonnyukinsaki () {
      if (!(!this.ikkatsuNyukinsakiFlg && this.tokuisakiFlg)) {
        return false
      }
      return true
    },
    isIkkatsunyukinsaki () {
      if (!(this.ikkatsuNyukinsakiFlg && this.tokuisakiFlg)) {
        return false
      }
      return true
    },
    otherNyukinRenrakusakiFlg () {
      return this.nyukinRenrakusakiKbn === '9'
    },
    isOtherNyukinRenrakusaki () {
      if (!(!this.ikkatsuNyukinsakiFlg && this.tokuisakiFlg && this.otherNyukinRenrakusakiFlg)) {
        return false
      }
      return true
    },
    isNotOtherNyukinRenrakusaki () {
      if (!(!this.ikkatsuNyukinsakiFlg && this.tokuisakiFlg && !this.otherNyukinRenrakusakiFlg)) {
        return false
      }
      return true
    },
    isShiiresaki () {
      if (!this.shiiresakiFlg) {
        return false
      }
      return true
    },
    isShiireHonshiharaisaki () {
      if (!(!this.ikkatsuShiharaisakiFlg && this.shiiresakiFlg)) {
        return false
      }
      return true
    },
    isShiireIkkatsushiharaisaki () {
      if (!(this.ikkatsuShiharaisakiFlg && this.shiiresakiFlg)) {
        return false
      }
      return true
    },
    isShiireKobetsuShiharaimeisaisho () {
      if (!(this.ikkatsuShiharaisakiFlg && this.shiiresakiFlg && this.shiiresakiKobetsuShiharaimeisaishoFlg)) {
        return false
      }
      return true
    },
    isHacchusaki () {
      if (!this.hacchusakiFlg) {
        return false
      }
      return true
    },
    isHacchuHonshiharaisaki () {
      if (!(!this.ikkatsuShiharaisakiFlg && this.hacchusakiFlg)) {
        return false
      }
      return true
    },
    isHacchuIkkatsushiharaisaki () {
      if (!(this.ikkatsuShiharaisakiFlg && this.hacchusakiFlg)) {
        return false
      }
      return true
    },
    isHacchuKobetsuShiharaimeisaisho () {
      if (!(this.ikkatsuShiharaisakiFlg && this.hacchusakiFlg && this.hacchusakiKobetsuShiharaimeisaishoFlg)) {
        return false
      }
      return true
    },
    isShiharaisaki () {
      if (!(this.shiiresakiFlg || this.hacchusakiFlg)) {
        return false
      }
      return true
    },
    otherShiharaitsuchiHassosakiFlg () {
      return this.shiharaitsuchiHassosakiKbn === '9'
    },
    isOtherShiharaiHassosaki () {
      if (!((!this.ikkatsuShiharaisakiFlg && this.shiiresakiFlg && this.otherShiharaitsuchiHassosakiFlg) ||
        (!this.ikkatsuShiharaisakiFlg && this.hacchusakiFlg && this.otherShiharaitsuchiHassosakiFlg))) {
        return false
      }
      return true
    },
    isNotOtherShiharaiHassosaki () {
      if (!((!this.ikkatsuShiharaisakiFlg && this.shiiresakiFlg && !this.otherShiharaitsuchiHassosakiFlg) ||
        (!this.ikkatsuShiharaisakiFlg && this.hacchusakiFlg && !this.otherShiharaitsuchiHassosakiFlg))) {
        return false
      }
      return true
    },
    otherShiharaitsuchiRenrakusakiFlg () {
      return this.shiharaitsuchiRenrakusakiKbn === '9'
    },
    isOtherShiharaiRenrakusaki () {
      if (!((!this.ikkatsuShiharaisakiFlg && this.shiiresakiFlg && this.otherShiharaitsuchiRenrakusakiFlg) ||
        (!this.ikkatsuShiharaisakiFlg && this.hacchusakiFlg && this.otherShiharaitsuchiRenrakusakiFlg))) {
        return false
      }
      return true
    },
    isNotOtherShiharaiRenrakusaki () {
      if (!((!this.ikkatsuShiharaisakiFlg && this.shiiresakiFlg && !this.otherShiharaitsuchiRenrakusakiFlg) ||
        (!this.ikkatsuShiharaisakiFlg && this.hacchusakiFlg && !this.otherShiharaitsuchiRenrakusakiFlg))) {
        return false
      }
      return true
    },
    isSeikyuTorihikisakiList () {
      if (!(this.id !== 0 && this.rec.seikyusakiList.length !== 0 && !this.ikkatsuSeikyusakiFlg)) {
        return false
      }
      return true
    },
    isNyukinTorihikisakiList () {
      if (!(this.id !== 0 && this.rec.nyukinsakiList.length !== 0 && !this.ikkatsuNyukinsakiFlg)) {
        return false
      }
      return true
    },
    isShiharaiTorihikisakiList () {
      if (!(this.id !== 0 && this.rec.shiharaisakiList.length !== 0 && !this.ikkatsuShiharaisakiFlg)) {
        return false
      }
      return true
    },
    isRirekiFukusyaDisplay () {
      if (this.modeOfEdit === 2 && (this.modeKengen === 1 || this.modeKengen === 2)) {
        console.log('★true')
        return true
      }
      console.log('★false')
      return false
    },
    isCancelButtonDisplay () {
      if (this.modeKengen === 0 || this.modeOfEdit === 1) {
        return false
      }
      return true
    },
    isDeleteButtonDisplay () {
      // if (this.modeKengen === 2 && (this.modeOfEdit === 0 || this.modeOfEdit === 2)) {
      if (this.modeKengen === 2 && this.modeOfEdit === 2) {
        return true
      }
      return false
    },
    isCopyButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit === 2) {
        return true
      }
      return false
    },
    isSaveButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit !== 1) {
        return true
      }
      return false
    },
    isShoukaiMode () {
      return this.modeOfEdit === 1
    },
    // 画面内で使うdatatableの変換用
    filteredSeikyusakiList () {
      // return this.rec.seikyusakiList
      return this.rec.seikyusakiList.map((elem) => {
        elem.warimashiJikanTankaDisp = elem.warimashiJikanTanka ? filter.numericFormatter(elem.warimashiJikanTanka) : ''
        elem.warimashiKyoriTankaDisp = elem.warimashiKyoriTanka ? filter.numericFormatter(elem.warimashiKyoriTanka) : ''
        elem.warimashiKeisuDisp = elem.warimashiKeisu ? filter.numericFormatter(elem.warimashiKeisu) : ''
        elem.warimashiNenryoKeisuDisp = elem.warimashiNenryoKeisu ? filter.numericFormatter(elem.warimashiNenryoKeisu) : ''
        return elem
      })
    },
    filteredNyukinsakiList () {
      return this.rec.nyukinsakiList
    },
    filteredShiharaisakiList () {
      return this.rec.shiharaisakiList.map((elem) => {
        elem.fuelTanka01Disp = elem.fuelTanka01 ? filter.numericFormatter(elem.fuelTanka01) : ''
        elem.fuelTanka02Disp = elem.fuelTanka02 ? filter.numericFormatter(elem.fuelTanka02) : ''
        elem.fuelTanka03Disp = elem.fuelTanka03 ? filter.numericFormatter(elem.fuelTanka03) : ''
        elem.fuelTanka04Disp = elem.fuelTanka04 ? filter.numericFormatter(elem.fuelTanka04) : ''
        elem.fuelTanka05Disp = elem.fuelTanka05 ? filter.numericFormatter(elem.fuelTanka05) : ''
        elem.fuelTanka99Disp = elem.fuelTanka99 ? filter.numericFormatter(elem.fuelTanka99) : ''
        elem.warimashiJikanTankaDisp = elem.warimashiJikanTanka ? filter.numericFormatter(elem.warimashiJikanTanka) : ''
        elem.warimashiKyoriTankaDisp = elem.warimashiKyoriTanka ? filter.numericFormatter(elem.warimashiKyoriTanka) : ''
        elem.warimashiKeisuDisp = elem.warimashiKeisu ? filter.numericFormatter(elem.warimashiKeisu) : ''
        return elem
      })
    }

  },
  created () {
    this.id = this.$route.params.id
    if (this.id === '0') {
      this.id = 0
    }
  },
  mounted () {
    this.initialize()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rec: this.rec,
        address1UseFlg: this.address1UseFlg,
        address2UseFlg: this.address2UseFlg,
        tokuisakiFlg: this.tokuisakiFlg,
        ikkatsuSeikyusakiFlg: this.ikkatsuSeikyusakiFlg,
        // otherSeikyushoHassosakiFlg: this.otherSeikyushoHassosakiFlg,
        seikyushoHassosakiKbn: this.seikyushoHassosakiKbn,
        // otherSeikyushoRenrakusakiFlg: this.otherSeikyushoRenrakusakiFlg,
        seikyushoRenrakusakiKbn: this.seikyushoRenrakusakiKbn,
        tokuisakiKobetsuSeikyumeisaishoFlg: this.tokuisakiKobetsuSeikyumeisaishoFlg,
        ikkatsuNyukinsakiFlg: this.ikkatsuNyukinsakiFlg,
        // otherNyukinRenrakusakiFlg: this.otherNyukinRenrakusakiFlg,
        nyukinRenrakusakiKbn: this.nyukinRenrakusakiKbn,
        shiiresakiFlg: this.shiiresakiFlg,
        shiiresakiKobetsuShiharaimeisaishoFlg: this.shiiresakiKobetsuShiharaimeisaishoFlg,
        hacchusakiFlg: this.hacchusakiFlg,
        hacchusakiSharyoKanriFlg: this.hacchusakiSharyoKanriFlg,
        hacchusakiKobetsuShiharaimeisaishoFlg: this.hacchusakiKobetsuShiharaimeisaishoFlg,
        ikkatsuShiharaisakiFlg: this.ikkatsuShiharaisakiFlg,
        // otherShiharaitsuchiHassosakiFlg: this.otherShiharaitsuchiHassosakiFlg,
        shiharaitsuchiHassosakiKbn: this.shiharaitsuchiHassosakiKbn,
        // otherShiharaitsuchiRenrakusakiFlg: this.otherShiharaitsuchiRenrakusakiFlg,
        shiharaitsuchiRenrakusakiKbn: this.shiharaitsuchiRenrakusakiKbn,
        shiharaiTorihikisakiCd: this.shiharaiTorihikisakiCd,
        add1AddressSeishikiNm: this.add1AddressSeishikiNm,
        add1AddressNm: this.add1AddressNm,
        add2AddressSeishikiNm: this.add2AddressSeishikiNm,
        add2AddressNm: this.add2AddressNm,
        seikyuHassoAddressSeishikiNm: this.seikyuHassoAddressSeishikiNm,
        seikyuHassoAddressNm: this.seikyuHassoAddressNm,
        seikyuRenrakuAddressSeishikiNm: this.seikyuRenrakuAddressSeishikiNm,
        seikyuRenrakuAddressNm: this.seikyuRenrakuAddressNm,
        nyukinRenrakuAddressSeishikiNm: this.nyukinRenrakuAddressSeishikiNm,
        nyukinRenrakuAddressNm: this.nyukinRenrakuAddressNm,
        shiharaiHassoAddressSeishikiNm: this.shiharaiHassoAddressSeishikiNm,
        shiharaiHassoAddressNm: this.shiharaiHassoAddressNm,
        shiharaiRenrakuAddressSeishikiNm: this.shiharaiRenrakuAddressSeishikiNm,
        shiharaiRenrakuAddressNm: this.shiharaiRenrakuAddressNm,
        seikyuTogetsuKijunHandanKbn: this.seikyuTogetsuKijunHandanKbn,
        shiharaiTogetsuKijunHandanKbn: this.shiharaiTogetsuKijunHandanKbn,
        shiharaiKozaSbt: this.shiharaiKozaSbt
      }
    },
    beforeRouteLeaveByMenu: function (next) {
      const opt = {
        nextCallback: next
      }
      this.preventTransition(opt)
    },
    fetchData: function () {
      console.log('fetchData')
      return new Promise((resolve) => {
        console.log(this.id)
        this.HttpClient
          .post(`/api/v1/vwCMstTorihikisaki/searchChildren?id=${this.id}`)
          .then((data) => {
            if (data.payload) {
              console.log('fetchData', data.payload)
              // 取引先マスタ
              this.rec.mstTorihikisaki = data.payload.mstTorihikisaki

              delete this.rec.mstTorihikisaki.tekiyoStartYmd
              delete this.rec.mstTorihikisaki.tekiyoEndYmd

              this.rec.mstTorihikisaki.torihikisakiBunruiKbn1 = data.payload.mstTorihikisaki.torihikisakiBunruiKbn1 ?? ''
              this.rec.mstTorihikisaki.torihikisakiBunruiKbn2 = data.payload.mstTorihikisaki.torihikisakiBunruiKbn2 ?? ''
              this.rec.mstTorihikisaki.torihikisakiBunruiKbn3 = data.payload.mstTorihikisaki.torihikisakiBunruiKbn3 ?? ''
              this.rec.mstTorihikisaki.chiikiSbt = data.payload.mstTorihikisaki.chiikiSbt ?? ''
              this.rec.mstTorihikisaki.chikuSbt = data.payload.mstTorihikisaki.chikuSbt ?? ''
              this.rec.mstTorihikisaki.seikyuKeisanRuleKbn = data.payload.mstTorihikisaki.seikyuKeisanRuleKbn ?? ''
              this.rec.mstTorihikisaki.shiireKeisanRuleKbn = data.payload.mstTorihikisaki.shiireKeisanRuleKbn ?? ''
              this.rec.mstTorihikisaki.hacchuKeisanRuleKbn = data.payload.mstTorihikisaki.hacchuKeisanRuleKbn ?? ''
              this.rec.mstTorihikisaki.color = [undefined, null, ''].includes(this.rec.mstTorihikisaki.color) ? '#b0bec5' : this.rec.mstTorihikisaki.color
              this.chipColorTmp = this.rec.mstTorihikisaki.color

              // 取引先基本アドレス
              this.rec.torihikisakiKihonAddress = data.payload.torihikisakiKihonAddress
              if (data.payload.mstTorihikisaki.addAddressId1) {
                this.address1UseFlg = true
                // 取引先追加アドレス１
                this.rec.torihikisakiAddAddress1 = data.payload.torihikisakiAddAddress1
                this.add1AddressSeishikiNm = data.payload.torihikisakiAddAddress1.addressSeishikiNm
                this.add1AddressNm = data.payload.torihikisakiAddAddress1.addressNm
              }
              if (data.payload.mstTorihikisaki.addAddressId2) {
                this.address2UseFlg = true
                // 取引先追加アドレス２
                this.rec.torihikisakiAddAddress2 = data.payload.torihikisakiAddAddress2
                this.add2AddressSeishikiNm = data.payload.torihikisakiAddAddress2.addressSeishikiNm
                this.add2AddressNm = data.payload.torihikisakiAddAddress2.addressNm
              }

              // 得意先マスタ
              if (data.payload.mstTorihikisaki.tokuisakiFlg) {
                this.tokuisakiFlg = data.payload.mstTorihikisaki.tokuisakiFlg
                this.rec.mstTokuisaki = data.payload.mstTokuisaki

                this.rec.mstTokuisaki.unchinKeisanKbn = data.payload.mstTokuisaki.unchinKeisanKbn ?? null
                this.rec.mstTokuisaki.seikyumeisaishoLayoutKbn = data.payload.mstTokuisaki.seikyumeisaishoLayoutKbn ?? null

                this.tokuisakiKobetsuSeikyumeisaishoFlg = data.payload.mstTokuisaki.tokuisakiKobetsuSeikyumeisaishoFlg
                // 得意先金額項目設定
                if (data.payload.tokuiKingaku) {
                  this.rec.tokuiKingaku = data.payload.tokuiKingaku
                }
              } else if (data.payload.mstTokuisaki.id === -1) {
                this.rec.mstTokuisaki.updDate = data.payload.mstTokuisaki.updDate
                if (data.payload.tokuiKingaku.id === -1) {
                  this.rec.tokuiKingaku.updDate = data.payload.tokuiKingaku.updDate
                }
              }

              // 請求先マスタ
              if (data.payload.mstTorihikisaki.tokuisakiFlg === true && data.payload.mstTorihikisaki.torihikisakiCd === data.payload.mstTorihikisaki.seikyuTorihikisakiCd) {
                this.ikkatsuSeikyusakiFlg = false
                this.rec.mstSeikyusaki = data.payload.mstSeikyusaki

                this.rec.mstSeikyusaki.shimeDay = data.payload.mstSeikyusaki.shimeDay?.trim()
                this.rec.mstSeikyusaki.nyukinDay = data.payload.mstSeikyusaki.nyukinDay?.trim()
                this.rec.mstSeikyusaki.seikyushoShukeiUnitKbn = data.payload.mstSeikyusaki.seikyushoShukeiUnitKbn ?? ''
                this.rec.mstSeikyusaki.unchinKeisanKbn = data.payload.mstSeikyusaki.unchinKeisanKbn ?? ''
                this.rec.mstSeikyusaki.seikyuMeisaishoLayoutKbn = data.payload.mstSeikyusaki.seikyuMeisaishoLayoutKbn ?? ''

                this.seikyuTogetsuKijunHandanKbn = data.payload.mstSeikyusaki.togetsuKijunHandanKbn

                if (data.payload.seikyusakiList.length !== 0) {
                  // 本請求に関係する取引先一覧
                  this.rec.seikyusakiList = data.payload.seikyusakiList
                }
                if (data.payload.mstTorihikisaki.kihonAddressId === data.payload.mstSeikyusaki.hassosakiAddressId) {
                  // this.otherSeikyushoHassosakiFlg = false
                  this.seikyushoHassosakiKbn = '0'
                } else if (data.payload.mstTorihikisaki.addAddressId1 === data.payload.mstSeikyusaki.hassosakiAddressId) {
                  // this.otherSeikyushoHassosakiFlg = false
                  this.seikyushoHassosakiKbn = '1'
                } else if (data.payload.mstTorihikisaki.addAddressId2 === data.payload.mstSeikyusaki.hassosakiAddressId) {
                  // this.otherSeikyushoHassosakiFlg = false
                  this.seikyushoHassosakiKbn = '2'
                } else {
                  // this.otherSeikyushoHassosakiFlg = true
                  this.seikyushoHassosakiKbn = '9'
                  // 請求発送先アドレス
                  this.rec.seikyushoHassosakiAddress = data.payload.seikyushoHassosakiAddress
                  this.seikyuHassoAddressSeishikiNm = data.payload.seikyushoHassosakiAddress.addressSeishikiNm
                  this.seikyuHassoAddressNm = data.payload.seikyushoHassosakiAddress.addressNm
                }
                if (data.payload.mstTorihikisaki.kihonAddressId === data.payload.mstSeikyusaki.renrakusakiAddressId) {
                  // this.otherSeikyushoRenrakusakiFlg = false
                  this.seikyushoRenrakusakiKbn = '0'
                } else if (data.payload.mstTorihikisaki.addAddressId1 === data.payload.mstSeikyusaki.renrakusakiAddressId) {
                  // this.otherSeikyushoRenrakusakiFlg = false
                  this.seikyushoRenrakusakiKbn = '1'
                } else if (data.payload.mstTorihikisaki.addAddressId2 === data.payload.mstSeikyusaki.renrakusakiAddressId) {
                  // this.otherSeikyushoRenrakusakiFlg = false
                  this.seikyushoRenrakusakiKbn = '2'
                } else {
                  // this.otherSeikyushoRenrakusakiFlg = true
                  this.seikyushoRenrakusakiKbn = '9'
                  // 請求連絡先アドレス
                  this.rec.seikyushoRenrakusakiAddress = data.payload.seikyushoRenrakusakiAddress
                  this.seikyuRenrakuAddressSeishikiNm = data.payload.seikyushoRenrakusakiAddress.addressSeishikiNm
                  this.seikyuRenrakuAddressNm = data.payload.seikyushoRenrakusakiAddress.addressNm
                }
              } else {
                if (data.payload.mstTorihikisaki.tokuisakiFlg === true && data.payload.mstTorihikisaki.torihikisakiCd !== data.payload.mstTorihikisaki.seikyuTorihikisakiCd) {
                  this.ikkatsuSeikyusakiFlg = true
                }
                if (data.payload.mstSeikyusaki.id === -1) {
                  this.rec.mstSeikyusaki.updDate = data.payload.mstSeikyusaki.updDate
                  if (data.payload.seikyushoHassosakiAddress.id === -1) {
                    this.rec.seikyushoHassosakiAddress.updDate = data.payload.seikyushoHassosakiAddress.updDate
                  }
                  if (data.payload.seikyushoRenrakusakiAddress.id === -1) {
                    this.rec.seikyushoRenrakusakiAddress.updDate = data.payload.seikyushoRenrakusakiAddress.updDate
                  }
                }
              }

              // 入金先マスタ
              if (data.payload.mstTorihikisaki.tokuisakiFlg === true && data.payload.mstTorihikisaki.torihikisakiCd === data.payload.mstTorihikisaki.nyukinTorihikisakiCd) {
                this.ikkatsuNyukinsakiFlg = false
                this.rec.mstNyukinsaki = data.payload.mstNyukinsaki

                // 本入金に関係する取引先一覧
                if (data.payload.nyukinsakiList.length !== 0) {
                  this.rec.nyukinsakiList = data.payload.nyukinsakiList
                }
                if (data.payload.mstTorihikisaki.kihonAddressId === data.payload.mstNyukinsaki.renrakusakiAddressId) {
                  // this.otherNyukinRenrakusakiFlg = false
                  this.nyukinRenrakusakiKbn = '0'
                } else if (data.payload.mstTorihikisaki.addAddressId1 === data.payload.mstNyukinsaki.renrakusakiAddressId) {
                  // this.otherNyukinRenrakusakiFlg = false
                  this.nyukinRenrakusakiKbn = '1'
                } else if (data.payload.mstTorihikisaki.addAddressId2 === data.payload.mstNyukinsaki.renrakusakiAddressId) {
                  // this.otherNyukinRenrakusakiFlg = false
                  this.nyukinRenrakusakiKbn = '2'
                } else {
                  // this.otherNyukinRenrakusakiFlg = true
                  this.nyukinRenrakusakiKbn = '9'
                  // 入金連絡先アドレス
                  this.rec.nyukinRenrakusakiAddress = data.payload.nyukinRenrakusakiAddress
                  this.nyukinRenrakuAddressSeishikiNm = data.payload.nyukinRenrakusakiAddress.addressSeishikiNm
                  this.nyukinRenrakuAddressNm = data.payload.nyukinRenrakusakiAddress.addressNm
                }
              } else {
                if (data.payload.mstTorihikisaki.tokuisakiFlg === true && data.payload.mstTorihikisaki.torihikisakiCd !== data.payload.mstTorihikisaki.nyukinTorihikisakiCd) {
                  this.ikkatsuNyukinsakiFlg = true
                }
                if (data.payload.mstNyukinsaki.id === -1) {
                  this.rec.mstNyukinsaki.updDate = data.payload.mstNyukinsaki.updDate
                  if (data.payload.nyukinRenrakusakiAddress.id === -1) {
                    this.rec.nyukinRenrakusakiAddress.updDate = data.payload.nyukinRenrakusakiAddress.updDate
                  }
                }
              }

              // 仕入先マスタ
              if (data.payload.mstTorihikisaki.shiiresakiFlg) {
                this.shiiresakiFlg = data.payload.mstTorihikisaki.shiiresakiFlg
                this.rec.mstShiiresaki = data.payload.mstShiiresaki

                this.rec.mstShiiresaki.shiharaimeisaishoLayoutKbn = data.payload.mstShiiresaki.shiharaimeisaishoLayoutKbn ?? ''

                this.shiiresakiKobetsuShiharaimeisaishoFlg = data.payload.mstShiiresaki.shiiresakiKobetsuShiharaimeisaishoFlg
                if (data.payload.shiireKingaku) {
                  // 仕入先金額項目設定
                  this.rec.shiireKingaku = data.payload.shiireKingaku
                }
              } else if (data.payload.mstShiiresaki.id === -1) {
                this.rec.mstShiiresaki.updDate = data.payload.mstShiiresaki.updDate
                if (data.payload.shiireKingaku.id === -1) {
                  this.rec.shiireKingaku.updDate = data.payload.shiireKingaku.updDate
                }
              }

              if (data.payload.mstTorihikisaki.hacchusakiFlg) {
                this.hacchusakiFlg = data.payload.mstTorihikisaki.hacchusakiFlg
                // 発注先マスタ
                this.rec.mstHacchusaki = data.payload.mstHacchusaki

                this.rec.mstHacchusaki.unchinKeisanKbn = data.payload.mstHacchusaki.unchinKeisanKbn ?? ''
                this.rec.mstHacchusaki.shiharaimeisaishoLayoutKbn = data.payload.mstHacchusaki.shiharaimeisaishoLayoutKbn ?? ''

                this.hacchusakiKobetsuShiharaimeisaishoFlg = data.payload.mstHacchusaki.hacchusakiKobetsuShiharaimeisaishoFlg
                if (data.payload.mstHacchusaki.mstKingakuId) {
                  // 発注先金額項目設定
                  this.rec.hacchuKingaku = data.payload.hacchuKingaku
                }
                if (![undefined, null].includes(data.payload.mstHacchusakiEigyosho) && data.payload.mstHacchusakiEigyosho.id > 0) {
                  this.rec.mstHacchusakiEigyosho = data.payload.mstHacchusakiEigyosho
                  this.hacchusakiSharyoKanriFlg = true
                }
              } else if (data.payload.mstHacchusaki.id === -1) {
                this.rec.mstHacchusaki.updDate = data.payload.mstHacchusaki.updDate
                if (data.payload.hacchuKingaku.id === -1) {
                  this.rec.hacchuKingaku.updDate = data.payload.hacchuKingaku.updDate
                }
              }

              // 支払先マスタ
              if ((data.payload.mstTorihikisaki.shiiresakiFlg === true || data.payload.mstTorihikisaki.hacchusakiFlg === true) &&
                  (data.payload.mstTorihikisaki.shiireTorihikisakiCd === data.payload.mstTorihikisaki.torihikisakiCd ||
                   data.payload.mstTorihikisaki.hacchuTorihikisakiCd === data.payload.mstTorihikisaki.torihikisakiCd)) {
                this.ikkatsuShiharaisakiFlg = false
                this.rec.mstShiharaisaki = data.payload.mstShiharaisaki

                if (data.payload.mstShiharaisaki.shimeDay !== null && data.payload.mstShiharaisaki.shimeDay !== undefined) {
                  this.rec.mstShiharaisaki.shimeDay = data.payload.mstShiharaisaki.shimeDay.trim()
                }
                if (data.payload.mstShiharaisaki.shiharaiDay !== null && data.payload.mstShiharaisaki.shiharaiDay !== undefined) {
                  this.rec.mstShiharaisaki.shiharaiDay = data.payload.mstShiharaisaki.shiharaiDay.trim()
                }
                if (data.payload.mstShiharaisaki.kinyuKikanCd !== null && data.payload.mstShiharaisaki.kinyuKikanCd !== undefined) {
                  this.rec.mstShiharaisaki.kinyuKikanCd = data.payload.mstShiharaisaki.kinyuKikanCd.trim()
                }
                if (data.payload.mstShiharaisaki.kinyuKikanShitenCd !== null && data.payload.mstShiharaisaki.kinyuKikanShitenCd !== undefined) {
                  this.rec.mstShiharaisaki.kinyuKikanShitenCd = data.payload.mstShiharaisaki.kinyuKikanShitenCd.trim()
                }
                if (data.payload.mstShiharaisaki.kozaNo !== null && data.payload.mstShiharaisaki.kozaNo !== undefined) {
                  this.rec.mstShiharaisaki.kozaNo = data.payload.mstShiharaisaki.kozaNo.trim()
                }
                this.rec.mstShiharaisaki.shiharaiKbn = data.payload.mstShiharaisaki.shiharaiKbn ?? ''
                this.rec.mstShiharaisaki.shiharaiShukeiUnitKbn = data.payload.mstShiharaisaki.shiharaiShukeiUnitKbn ?? ''
                this.rec.mstShiharaisaki.shiharaiTsuchishoLayoutKbn = data.payload.mstShiharaisaki.shiharaiTsuchishoLayoutKbn ?? ''
                this.rec.mstShiharaisaki.shiharaiMeisaishoLayoutKbn = data.payload.mstShiharaisaki.shiharaiMeisaishoLayoutKbn ?? ''

                this.shiharaiTogetsuKijunHandanKbn = data.payload.mstShiharaisaki.togetsuKijunHandanKbn
                this.shiharaiKozaSbt = data.payload.mstShiharaisaki.kozaSbt

                if (data.payload.shiharaisakiList.length !== 0) {
                  // 本支払に関係する取引先一覧
                  this.rec.shiharaisakiList = data.payload.shiharaisakiList
                }
                if (data.payload.mstTorihikisaki.kihonAddressId === data.payload.mstShiharaisaki.hassosakiAddressId) {
                  // this.otherShiharaitsuchiHassosakiFlg = false
                  this.shiharaitsuchiHassosakiKbn = '0'
                } else if (data.payload.mstTorihikisaki.addAddressId1 === data.payload.mstShiharaisaki.hassosakiAddressId) {
                  // this.otherShiharaitsuchiHassosakiFlg = false
                  this.shiharaitsuchiHassosakiKbn = '1'
                } else if (data.payload.mstTorihikisaki.addAddressId2 === data.payload.mstShiharaisaki.hassosakiAddressId) {
                  // this.otherShiharaitsuchiHassosakiFlg = false
                  this.shiharaitsuchiHassosakiKbn = '2'
                } else {
                  // this.otherShiharaitsuchiHassosakiFlg = true
                  this.shiharaitsuchiHassosakiKbn = '9'
                  // 支払発送先アドレス
                  this.rec.shiharaitsuchiHassosakiAddress = data.payload.shiharaitsuchiHassosakiAddress
                  this.shiharaiHassoAddressSeishikiNm = data.payload.shiharaitsuchiHassosakiAddress.addressSeishikiNm
                  this.shiharaiHassoAddressNm = data.payload.shiharaitsuchiHassosakiAddress.addressNm
                }
                if (data.payload.mstTorihikisaki.kihonAddressId === data.payload.mstShiharaisaki.renrakusakiAddressId) {
                  // this.otherShiharaitsuchiRenrakusakiFlg = false
                  this.shiharaitsuchiRenrakusakiKbn = '0'
                } else if (data.payload.mstTorihikisaki.addAddressId1 === data.payload.mstShiharaisaki.renrakusakiAddressId) {
                  // this.otherShiharaitsuchiRenrakusakiFlg = false
                  this.shiharaitsuchiRenrakusakiKbn = '1'
                } else if (data.payload.mstTorihikisaki.addAddressId2 === data.payload.mstShiharaisaki.renrakusakiAddressId) {
                  // this.otherShiharaitsuchiRenrakusakiFlg = false
                  this.shiharaitsuchiRenrakusakiKbn = '2'
                } else {
                  // this.otherShiharaitsuchiRenrakusakiFlg = true
                  this.shiharaitsuchiRenrakusakiKbn = '9'
                  // 支払連絡先アドレス
                  this.rec.shiharaitsuchiRenrakusakiAddress = data.payload.shiharaitsuchiRenrakusakiAddress
                  this.shiharaiRenrakuAddressSeishikiNm = data.payload.shiharaitsuchiRenrakusakiAddress.addressSeishikiNm
                  this.shiharaiRenrakuAddressNm = data.payload.shiharaitsuchiRenrakusakiAddress.addressNm
                }
              } else {
                if ((data.payload.mstTorihikisaki.shiiresakiFlg === true || data.payload.mstTorihikisaki.hacchusakiFlg === true) &&
                    (data.payload.mstTorihikisaki.shiireTorihikisakiCd !== data.payload.mstTorihikisaki.torihikisakiCd &&
                      data.payload.mstTorihikisaki.hacchuTorihikisakiCd !== data.payload.mstTorihikisaki.torihikisakiCd)) {
                  this.ikkatsuShiharaisakiFlg = true
                  if (data.payload.mstTorihikisaki.shiiresakiFlg === true) {
                    this.shiharaiTorihikisakiCd = data.payload.mstTorihikisaki.shiireTorihikisakiCd
                  } else if (data.payload.mstTorihikisaki.hacchusakiFlg === true) {
                    this.shiharaiTorihikisakiCd = data.payload.mstTorihikisaki.hacchuTorihikisakiCd
                  }
                }
                if (data.payload.mstShiharaisaki.id === -1) {
                  this.rec.mstShiharaisaki.updDate = data.payload.mstShiharaisaki.updDate
                  if (data.payload.shiharaitsuchiHassosakiAddress.id === -1) {
                    this.rec.shiharaitsuchiHassosakiAddress.updDate = data.payload.shiharaitsuchiHassosakiAddress.updDate
                  }
                  if (data.payload.shiharaitsuchiRenrakusakiAddress.id === -1) {
                    this.rec.shiharaitsuchiRenrakusakiAddress.updDate = data.payload.shiharaitsuchiRenrakusakiAddress.updDate
                  }
                }
              }
            }
            resolve()
          })
      })
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msyskubun', 'mstshubetsu', 'vwcmsteigyoshojininlist', 'msttorihikisaki', 'msthacchakuchi', 'msthinmei', 'mstkihonjoho', 'vwcmsttorihikisakigetnyukinsaki', 'vwcmsttorihikisakigetshiharaisaki', 'vwcmsttorihikisakigetseikyusaki'],
        initializeInputPromise: () => {
          return new Promise((resolve) => {
            self.HttpClient
              .get(`/api/v1/MstKingaku/FindByType?id=${0}&kinKbn=${0}`)
              .then((data) => {
                const initKingaku = data.payload ? data.payload : {
                  kihonUnchinShiyoFlg: true,
                  kihonUnchinTitle: '基本運賃(課税)',
                  kihonUnchinShukeiKbn: '01',
                  hiwayPriceShiyoFlg: true,
                  hiwayPriceTitle: '時間割増金額(課税)',
                  hiwayPriceShukeiKbn: '01',
                  jikanWarimashiKingakuShiyoFlg: true,
                  jikanWarimashiKingakuTitle: '距離割増金額(課税)',
                  jikanWarimashiKingakuShukeiKbn: '01',
                  kyoriWarimashiKingakuShiyoFlg: true,
                  kyoriWarimashiKingakuTitle: '係数割増金額(課税)',
                  kyoriWarimashiKingakuShukeiKbn: '01',
                  keisuWarimashiKingakuShiyoFlg: true,
                  keisuWarimashiKingakuTitle: '燃料割増金額(課税)',
                  keisuWarimashiKingakuShukeiKbn: '01',
                  nenryoWarimashiKingakuShiyoFlg: true,
                  nenryoWarimashiKingakuTitle: '高速代(内税)',
                  nenryoWarimashiKingakuShukeiKbn: '01',
                  userKingakuKazei1ShiyoFlg: true,
                  userKingakuKazei1Title: 'ユーザ金額(課税)１',
                  userKingakuKazei1ShukeiKbn: '01',
                  userKingakuKazei2ShiyoFlg: true,
                  userKingakuKazei2Title: 'ユーザ金額(課税)２',
                  userKingakuKazei2ShukeiKbn: '01',
                  userKingakuKazei3ShiyoFlg: true,
                  userKingakuKazei3Title: 'ユーザ金額(課税)３',
                  userKingakuKazei3ShukeiKbn: '01',
                  userKingakuKazei4ShiyoFlg: true,
                  userKingakuKazei4Title: 'ユーザ金額(課税)４',
                  userKingakuKazei4ShukeiKbn: '01',
                  userKingakuKazei5ShiyoFlg: true,
                  userKingakuKazei5Title: 'ユーザ金額(課税)５',
                  userKingakuKazei5ShukeiKbn: '01',
                  userKingakuKazei6ShiyoFlg: true,
                  userKingakuKazei6Title: 'ユーザ金額(課税)６',
                  userKingakuKazei6ShukeiKbn: '01',
                  userKingakuKazei7ShiyoFlg: true,
                  userKingakuKazei7Title: 'ユーザ金額(課税)７',
                  userKingakuKazei7ShukeiKbn: '01',
                  userKingakuKazei8ShiyoFlg: true,
                  userKingakuKazei8Title: 'ユーザ金額(課税)８',
                  userKingakuKazei8ShukeiKbn: '01',
                  userKingakuKazei9ShiyoFlg: true,
                  userKingakuKazei9Title: 'ユーザ金額(課税)９',
                  userKingakuKazei9ShukeiKbn: '01',
                  userKingakuKazei10ShiyoFlg: true,
                  userKingakuKazei10Title: 'ユーザ金額(課税)１０',
                  userKingakuKazei10ShukeiKbn: '01',
                  userKingakuHikazei1ShiyoFlg: true,
                  userKingakuHikazei1Title: 'ユーザ金額(非課税)１',
                  userKingakuHikazei1ShukeiKbn: '01',
                  userKingakuHikazei2ShiyoFlg: true,
                  userKingakuHikazei2Title: 'ユーザ金額(非課税)２',
                  userKingakuHikazei2ShukeiKbn: '01',
                  userKingakuHikazei3ShiyoFlg: true,
                  userKingakuHikazei3Title: 'ユーザ金額(非課税)３',
                  userKingakuHikazei3ShukeiKbn: '01',
                  userKingakuHikazei4ShiyoFlg: true,
                  userKingakuHikazei4Title: 'ユーザ金額(非課税)４',
                  userKingakuHikazei4ShukeiKbn: '01',
                  userKingakuHikazei5ShiyoFlg: true,
                  userKingakuHikazei5Title: 'ユーザ金額(非課税)５',
                  userKingakuHikazei5ShukeiKbn: '01',
                  userKingakuHikazei6ShiyoFlg: true,
                  userKingakuHikazei6Title: 'ユーザ金額(非課税)６',
                  userKingakuHikazei6ShukeiKbn: '01',
                  userKingakuHikazei7ShiyoFlg: true,
                  userKingakuHikazei7Title: 'ユーザ金額(非課税)７',
                  userKingakuHikazei7ShukeiKbn: '01',
                  userKingakuHikazei8ShiyoFlg: true,
                  userKingakuHikazei8Title: 'ユーザ金額(非課税)８',
                  userKingakuHikazei8ShukeiKbn: '01',
                  userKingakuHikazei9ShiyoFlg: true,
                  userKingakuHikazei9Title: 'ユーザ金額(非課税)９',
                  userKingakuHikazei9ShukeiKbn: '01',
                  userKingakuHikazei10ShiyoFlg: true,
                  userKingakuHikazei10Title: 'ユーザ金額(非課税)１０',
                  userKingakuHikazei10ShukeiKbn: '01',
                  userKingakuUchizei1ShiyoFlg: true,
                  userKingakuUchizei1Title: 'ユーザ金額(内税)１',
                  userKingakuUchizei1ShukeiKbn: '01',
                  userKingakuUchizei2ShiyoFlg: true,
                  userKingakuUchizei2Title: 'ユーザ金額(内税)２',
                  userKingakuUchizei2ShukeiKbn: '01',
                  userKingakuUchizei3ShiyoFlg: true,
                  userKingakuUchizei3Title: 'ユーザ金額(内税)３',
                  userKingakuUchizei3ShukeiKbn: '01',
                  userKingakuUchizei4ShiyoFlg: true,
                  userKingakuUchizei4Title: 'ユーザ金額(内税)４',
                  userKingakuUchizei4ShukeiKbn: '01',
                  userKingakuUchizei5ShiyoFlg: true,
                  userKingakuUchizei5Title: 'ユーザ金額(内税)５',
                  userKingakuUchizei5ShukeiKbn: '01',
                  userKingakuUchizei6ShiyoFlg: true,
                  userKingakuUchizei6Title: 'ユーザ金額(内税)６',
                  userKingakuUchizei6ShukeiKbn: '01',
                  userKingakuUchizei7ShiyoFlg: true,
                  userKingakuUchizei7Title: 'ユーザ金額(内税)７',
                  userKingakuUchizei7ShukeiKbn: '01',
                  userKingakuUchizei8ShiyoFlg: true,
                  userKingakuUchizei8Title: 'ユーザ金額(内税)８',
                  userKingakuUchizei8ShukeiKbn: '01',
                  userKingakuUchizei9ShiyoFlg: true,
                  userKingakuUchizei9Title: 'ユーザ金額(内税)９',
                  userKingakuUchizei9ShukeiKbn: '01',
                  userKingakuUchizei10ShiyoFlg: true,
                  userKingakuUchizei10Title: 'ユーザ金額(内税)１０',
                  userKingakuUchizei10ShukeiKbn: '01'
                }
                self.rec = {
                  mstTorihikisaki: {
                    torihikisakiBunruiKbn1: null,
                    torihikisakiBunruiKbn2: null,
                    torihikisakiBunruiKbn3: null,
                    color: '#00FF00',
                    chiikiSbt: null,
                    chikuSbt: null,
                    seikyuKeisanRuleKbn: '01',
                    shiireKeisanRuleKbn: '01',
                    hacchuKeisanRuleKbn: '01',
                    tekiyoStartYmdString: '2000/01/01',
                    tekiyoEndYmdString: '2100/01/01',
                    hyojiOrder: '9999'
                  },
                  torihikisakiKihonAddress: {},
                  torihikisakiAddAddress1: {},
                  torihikisakiAddAddress2: {},
                  mstTokuisaki: {
                    unchinHasuKeisanKbn: null,
                    unchinKeisanKbn: null,
                    keijobiKbn: '1',
                    suryoKeijoKbn: '1',
                    seikyumeisaishoLayoutKbn: '01'
                  },
                  tokuiKingaku: Object.assign({}, initKingaku),
                  mstSeikyusaki: {
                    togetsuKijunHandanKbn: '01',
                    seikyushoShukeiUnitKbn: null,
                    seikyushoShiharaiOutputFlg: false,
                    seikyushoKaishaNmOutputFlg: false,
                    nyukinKbn: null,
                    taxHasuKeisanKbn: null,
                    taxKeisanUnitKbn: null,
                    seikyushoLayoutKbn: 'DDT',
                    seikyuMeisaishoLayoutKbn: 'DDT'
                  },
                  seikyushoHassosakiAddress: {},
                  seikyushoRenrakusakiAddress: {},
                  seikyusakiList: [],
                  mstNyukinsaki: {
                    nyukinKbn: null,
                    furikomiTesuryoFlg: false
                  },
                  nyukinRenrakusakiAddress: {},
                  nyukinsakiList: [],
                  mstShiiresaki: {
                    shiharaimeisaishoLayoutKbn: '01'
                  },
                  shiireKingaku: Object.assign({}, initKingaku),
                  mstHacchusaki: {
                    unchinHasuKeisanKbn: null,
                    unchinKeisanKbn: null,
                    shiharaimeisaishoLayoutKbn: '01'
                  },
                  hacchuKingaku: Object.assign({}, initKingaku),
                  mstShiharaisaki: {
                    shiharaiKbn: null,
                    taxHasuKeisanKbn: null,
                    taxKeisanUnitKbn: null,
                    togetsuKijunHandanKbn: '01',
                    shiharaiShukeiUnitKbn: '01',
                    shiharaiTsuchishoLayoutKbn: '01',
                    shiharaiMeisaishoLayoutKbn: '01',
                    shiharaiShukkinmeisaiOutputFlg: false,
                    shiharaiKaishaNmOutputFlg: false,
                    kozaSbt: '1'
                  },
                  shiharaitsuchiHassosakiAddress: {},
                  shiharaitsuchiRenrakusakiAddress: {},
                  shiharaisakiList: []
                }
                self.tokuiKingakuDialog = false
                self.shiireKingakuDialog = false
                self.hacchuKingakuDialog = false
                self.tab = 'tab1'
                self.address1UseFlg = false
                self.address2UseFlg = false
                self.tokuisakiFlg = false
                self.ikkatsuSeikyusakiFlg = false
                // self.otherSeikyushoHassosakiFlg = false
                self.seikyushoHassosakiKbn = '0'
                // self.otherSeikyushoRenrakusakiFlg = false
                self.seikyushoRenrakusakiKbn = '0'
                self.tokuisakiKobetsuSeikyumeisaishoFlg = false
                self.ikkatsuNyukinsakiFlg = false
                // self.otherNyukinRenrakusakiFlg = false
                self.nyukinRenrakusakiKbn = '0'
                self.shiiresakiFlg = false
                self.shiiresakiKobetsuShiharaimeisaishoFlg = false
                self.hacchusakiFlg = false
                self.hacchusakiSharyoKanriFlg = false
                self.hacchusakiKobetsuShiharaimeisaishoFlg = false
                self.ikkatsuShiharaisakiFlg = false
                // self.otherShiharaitsuchiHassosakiFlg = false
                self.shiharaitsuchiHassosakiKbn = '0'
                // self.otherShiharaitsuchiRenrakusakiFlg = false
                self.shiharaitsuchiRenrakusakiKbn = '0'
                self.shiharaiTorihikisakiCd = ''
                self.add1AddressSeishikiNm = ''
                self.add1AddressNm = ''
                self.add2AddressSeishikiNm = ''
                self.add2AddressNm = ''
                self.seikyuHassoAddressSeishikiNm = ''
                self.seikyuHassoAddressNm = ''
                self.seikyuRenrakuAddressSeishikiNm = ''
                self.seikyuRenrakuAddressNm = ''
                self.nyukinRenrakuAddressSeishikiNm = ''
                self.nyukinRenrakuAddressNm = ''
                self.shiharaiHassoAddressSeishikiNm = ''
                self.shiharaiHassoAddressNm = ''
                self.shiharaiRenrakuAddressSeishikiNm = ''
                self.shiharaiRenrakuAddressNm = ''
                self.seikyuTogetsuKijunHandanKbn = '01'
                self.shiharaiTogetsuKijunHandanKbn = '01'
                self.shiharaiKozaSbt = '1'
                self.chipColorTmp = self.rec.mstTorihikisaki.color
                self.kingaku = Object.assign({}, initKingaku)
              })
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          return new Promise((resolve) => {
            console.log('savedInputRestorePromise')
            if (c.seikyuKeisanRuleKbn !== undefined) {
              self.rec.mstTorihikisaki.seikyuKeisanRuleKbn = c.seikyuKeisanRuleKbn
              self.rec.mstTorihikisaki.shiireKeisanRuleKbn = c.shiireKeisanRuleKbn
              self.rec.mstTorihikisaki.hacchuKeisanRuleKbn = c.hacchuKeisanRuleKbn
              self.seikyuTogetsuKijunHandanKbn = c.seikyuTogetsuKijunHandanKbn
              self.rec.mstSeikyusaki.taxHasuKeisanKbn = c.seikyuTaxHasuKeisanKbn
              self.rec.mstSeikyusaki.taxKeisanUnitKbn = c.seikyuTaxKeisanUnitKbn
              self.rec.mstSeikyusaki.seikyushoShiharaiOutputFlg = c.seikyushoShiharaiOutputFlg.toLowerCase() === 'true'
              self.rec.mstSeikyusaki.seikyushoKaishaNmOutputFlg = c.seikyushoKaishaNmOutputFlg.toLowerCase() === 'true'
              // self.otherSeikyushoHassosakiFlg = c.otherSeikyushoHassosakiFlg.toLowerCase() === 'true'
              // self.otherSeikyushoRenrakusakiFlg = c.otherSeikyushoRenrakusakiFlg.toLowerCase() === 'true'
              self.rec.mstTokuisaki.unchinHasuKeisanKbn = c.tokuiUnchinHasuKeisanKbn
              self.rec.mstTokuisaki.unchinKeisanKbn = c.tokuiUnchinKeisanKbn
              self.rec.mstNyukinsaki.furikomiTesuryoFlg = c.furikomiTesuryoFlg.toLowerCase() === 'true'
              // self.otherNyukinRenrakusakiFlg = c.otherNyukinRenrakusakiFlg.toLowerCase() === 'true'
              self.rec.mstHacchusaki.unchinHasuKeisanKbn = c.hacchusakiUnchinHasuKeisanKbn
              self.rec.mstHacchusaki.unchinKeisanKbn = c.hacchusakiUnchinKeisanKbn
              self.shiharaiTogetsuKijunHandanKbn = c.shiharaiTogetsuKijunHandanKbn
              self.rec.mstShiharaisaki.taxHasuKeisanKbn = c.shiharaiTaxHasuKeisanKbn
              self.rec.mstShiharaisaki.taxKeisanUnitKbn = c.shiharaiTaxKeisanUnitKbn
              self.rec.mstShiharaisaki.shiharaiShukkinmeisaiOutputFlg = c.shiharaiShukkinmeisaiOutputFlg.toLowerCase() === 'true'
              self.rec.mstShiharaisaki.shiharaiKaishaNmOutputFlg = c.shiharaiKaishaNmOutputFlg.toLowerCase() === 'true'
              // self.otherShiharaitsuchiHassosakiFlg = c.otherShiharaitsuchiHassosakiFlg.toLowerCase() === 'true'
              // self.otherShiharaitsuchiRenrakusakiFlg = c.otherShiharaitsuchiRenrakusakiFlg.toLowerCase() === 'true'
            }
            console.log('◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆', self.rec.mstHacchusaki.unchinKeisanKbn)
            resolve()
          })
        },
        existsIdMethod: () => {
          return this.id !== 0
        },
        requestApiPromise: this.fetchData,
        settingButtonStatePromise: (kengen) => {
          return new Promise((resolve) => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              this.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              this.modeKengen = 1
            } else {
              // フルアクセス
              this.modeKengen = 2
            }
            // thisId == 0 then 新規モード
            if (this.id === 0) {
              this.modeOfEdit = 0 // 新規モード
            } else if (this.modeKengen === 0) {
              this.modeOfEdit = 1 // 照会モード
            } else {
              this.modeOfEdit = 2 // 更新モード
            }
            console.log('modeOfEdit', this.modeOfEdit)
            console.log('modeKengen', this.modeKengen)

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        },
        settingItemMethod: (kengen) => {
          console.log('settingItemMethod', kengen)
        }
      }
      console.info('call initializeForRegister', this.initializeForRegister, opt)
      this.initializeForRegister(opt)
    },
    onTokuisakiKingakuConfigOpen: function (e) {
      this.tokuiKingakuDialog = true
    },
    onTokuisakiKingakuConfigClose: function (e) {
      this.rec.tokuiKingaku = Object.assign({}, e)
      this.tokuiKingakuDialog = false
    },
    onShiiresakiKingakuConfigOpen: function (e) {
      this.shiireKingakuDialog = true
    },
    onShiiresakiKingakuConfigClose: function (e) {
      this.rec.shiireKingaku = Object.assign({}, e)
      this.shiireKingakuDialog = false
    },
    onHacchusakiKingakuConfigOpen: function (e) {
      this.hacchuKingakuDialog = true
    },
    onHacchusakiKingakuConfigClose: function (e) {
      this.rec.hacchuKingaku = Object.assign({}, e)
      this.hacchuKingakuDialog = false
    },
    onAdd1SeishikimeishoCopyClick: function (e) {
      console.log('onAdd1SeishikimeishoCopyClick', e)
      this.add1AddressSeishikiNm = this.rec.mstTorihikisaki.torihikisakiSeishikiNm
    },
    onAdd1MeishoCopyClick: function (e) {
      console.log('onAdd1MeishoClick', e)
      this.add1AddressNm = this.rec.mstTorihikisaki.torihikisakiNm
    },
    onAdd2SeishikimeishoCopyClick: function (e) {
      console.log('onAdd2SeishikimeishoCopyClick', e)
      this.add2AddressSeishikiNm = this.rec.mstTorihikisaki.torihikisakiSeishikiNm
    },
    onAdd2MeishoCopyClick: function (e) {
      console.log('onAdd2MeishoClick', e)
      this.add2AddressNm = this.rec.mstTorihikisaki.torihikisakiNm
    },
    onSeikyuHassoSeishikimeishoCopyClick: function (e) {
      console.log('onSeikyuHassoSeishikimeishoCopyClick', e)
      this.seikyuHassoAddressSeishikiNm = this.rec.mstTorihikisaki.torihikisakiSeishikiNm
    },
    onSeikyuHassoMeishoCopyClick: function (e) {
      console.log('onSeikyuHassoMeishoClick', e)
      this.seikyuHassoAddressNm = this.rec.mstTorihikisaki.torihikisakiNm
    },
    onSeikyuRenrakuSeishikimeishoCopyClick: function (e) {
      console.log('onSeikyuRenrakuSeishikimeishoCopyClick', e)
      this.seikyuRenrakuAddressSeishikiNm = this.rec.mstTorihikisaki.torihikisakiSeishikiNm
    },
    onSeikyuRenrakuMeishoCopyClick: function (e) {
      console.log('onSeikyuRenrakuMeishoClick', e)
      this.seikyuRenrakuAddressNm = this.rec.mstTorihikisaki.torihikisakiNm
    },
    onNyukinRenrakuSeishikimeishoCopyClick: function (e) {
      console.log('onNyukinRenrakuSeishikimeishoCopyClick', e)
      this.nyukinRenrakuAddressSeishikiNm = this.rec.mstTorihikisaki.torihikisakiSeishikiNm
    },
    onNyukinRenrakuMeishoCopyClick: function (e) {
      console.log('onNyukinRenrakuMeishoClick', e)
      this.nyukinRenrakuAddressNm = this.rec.mstTorihikisaki.torihikisakiNm
    },
    onShiharaiHassoSeishikimeishoCopyClick: function (e) {
      console.log('onShiharaiHassoSeishikimeishoCopyClick', e)
      this.shiharaiHassoAddressSeishikiNm = this.rec.mstTorihikisaki.torihikisakiSeishikiNm
    },
    onShiharaiHassoMeishoCopyClick: function (e) {
      console.log('onShiharaiHassoMeishoClick', e)
      this.shiharaiHassoAddressNm = this.rec.mstTorihikisaki.torihikisakiNm
    },
    onShiharaiRenrakuSeishikimeishoCopyClick: function (e) {
      console.log('onShiharaiRenrakuSeishikimeishoCopyClick', e)
      this.shiharaiRenrakuAddressSeishikiNm = this.rec.mstTorihikisaki.torihikisakiSeishikiNm
    },
    onShiharaiRenrakuMeishoCopyClick: function (e) {
      console.log('onShiharaiRenrakuMeishoClick', e)
      this.shiharaiRenrakuAddressNm = this.rec.mstTorihikisaki.torihikisakiNm
    },
    changeAddAddress1Flg: function (e) {
      console.log('addAddress1Flg', e)
      if (!e) {
        if (this.seikyushoHassosakiKbn === '1') this.seikyushoHassosakiKbn = '0'
        if (this.seikyushoRenrakusakiKbn === '1') this.seikyushoRenrakusakiKbn = '0'
        if (this.nyukinRenrakusakiKbn === '1') this.nyukinRenrakusakiKbn = '0'
        if (this.shiharaitsuchiHassosakiKbn === '1') this.shiharaitsuchiHassosakiKbn = '0'
        if (this.shiharaitsuchiRenrakusakiKbn === '1') this.shiharaitsuchiRenrakusakiKbn = '0'
      }
    },
    changeAddAddress2Flg: function (e) {
      console.log('addAddress2Flg', e)
      if (!e) {
        if (this.seikyushoHassosakiKbn === '2') this.seikyushoHassosakiKbn = '0'
        if (this.seikyushoRenrakusakiKbn === '2') this.seikyushoRenrakusakiKbn = '0'
        if (this.nyukinRenrakusakiKbn === '2') this.nyukinRenrakusakiKbn = '0'
        if (this.shiharaitsuchiHassosakiKbn === '2') this.shiharaitsuchiHassosakiKbn = '0'
        if (this.shiharaitsuchiRenrakusakiKbn === '2') this.shiharaitsuchiRenrakusakiKbn = '0'
      }
    },
    onRirekiFukushaButtonClick: function (e) {
      console.log('onRirekiFukushaButtonClick', e)
    },
    // --------------------------------------------------------------------------------
    // カラーリセット
    // --------------------------------------------------------------------------------
    onUndoChipColor: function () {
      this.rec.mstTorihikisaki.color = this.chipColorTmp
    },
    onReturnButtonClick: function (e) {
      console.log('onReturnButtonClick', e)
      const self = this
      const opt = {
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        }
      }

      this.transitionBack(opt)
    },
    onCancelButtonClick: function (e) {
      console.log('onCancelButtonClick', e)
      const self = this
      const opt = {
        restoreInputsPromise: function (data) {
          return new Promise(resolve => {
            self.rec = data().rec
            self.address1UseFlg = data().address1UseFlg
            self.address2UseFlg = data().address2UseFlg
            self.tokuisakiFlg = data().tokuisakiFlg
            self.ikkatsuSeikyusakiFlg = data().ikkatsuSeikyusakiFlg
            // self.otherSeikyushoHassosakiFlg = data().otherSeikyushoHassosakiFlg
            self.seikyushoHassosakiKbn = data().seikyushoHassosakiKbn
            // self.otherSeikyushoRenrakusakiFlg = data().otherSeikyushoRenrakusakiFlg
            self.seikyushoRenrakusakiKbn = data().seikyushoRenrakusakiKbn
            self.tokuisakiKobetsuSeikyumeisaishoFlg = data().tokuisakiKobetsuSeikyumeisaishoFlg
            self.ikkatsuNyukinsakiFlg = data().ikkatsuNyukinsakiFlg
            // self.otherNyukinRenrakusakiFlg = data().otherNyukinRenrakusakiFlg
            self.nyukinRenrakusakiKbn = data().nyukinRenrakusakiKbn
            self.shiiresakiFlg = data().shiiresakiFlg
            self.shiiresakiKobetsuShiharaimeisaishoFlg = data().shiiresakiKobetsuShiharaimeisaishoFlg
            self.hacchusakiFlg = data().hacchusakiFlg
            self.hacchusakiSharyoKanriFlg = data().hacchusakiSharyoKanriFlg
            self.hacchusakiKobetsuShiharaimeisaishoFlg = data().hacchusakiKobetsuShiharaimeisaishoFlg
            self.ikkatsuShiharaisakiFlg = data().ikkatsuShiharaisakiFlg
            // self.otherShiharaitsuchiHassosakiFlg = data().otherShiharaitsuchiHassosakiFlg
            self.shiharaitsuchiHassosakiKbn = data().shiharaitsuchiHassosakiKbn
            // self.otherShiharaitsuchiRenrakusakiFlg = data().otherShiharaitsuchiRenrakusakiFlg
            self.shiharaitsuchiRenrakusakiKbn = data().shiharaitsuchiRenrakusakiKbn
            self.shiharaiTorihikisakiCd = data().shiharaiTorihikisakiCd
            self.add1AddressSeishikiNm = data().add1AddressSeishikiNm
            self.add1AddressNm = data().add1AddressNm
            self.add2AddressSeishikiNm = data().add2AddressSeishikiNm
            self.add2AddressNm = data().add2AddressNm
            self.seikyuHassoAddressSeishikiNm = data().seikyuHassoAddressSeishikiNm
            self.seikyuHassoAddressNm = data().seikyuHassoAddressNm
            self.seikyuRenrakuAddressSeishikiNm = data().seikyuRenrakuAddressSeishikiNm
            self.seikyuRenrakuAddressNm = data().seikyuRenrakuAddressNm
            self.nyukinRenrakuAddressSeishikiNm = data().nyukinRenrakuAddressSeishikiNm
            self.nyukinRenrakuAddressNm = data().nyukinRenrakuAddressNm
            self.shiharaiHassoAddressSeishikiNm = data().shiharaiHassoAddressSeishikiNm
            self.shiharaiHassoAddressNm = data().shiharaiHassoAddressNm
            self.shiharaiRenrakuAddressSeishikiNm = data().shiharaiRenrakuAddressSeishikiNm
            self.shiharaiRenrakuAddressNm = data().shiharaiRenrakuAddressNm
            self.seikyuTogetsuKijunHandanKbn = data().seikyuTogetsuKijunHandanKbn
            self.shiharaiTogetsuKijunHandanKbn = data().shiharaiTogetsuKijunHandanKbn
            self.shiharaiKozaSbt = data().shiharaiKozaSbt
            if (self.id === 0) {
              self.rec.mstTorihikisaki.id = 0
              self.rec.mstTorihikisaki.kihonAddressId = null
              self.rec.mstTorihikisaki.addAddressId1 = null
              self.rec.mstTorihikisaki.addAddressId2 = null
              self.rec.mstTokuisaki.mstTorihikisakiId = null
              self.rec.mstTokuisaki.mstKingakuId = null
              self.rec.mstSeikyusaki.mstTorihikisakiId = null
              self.rec.mstSeikyusaki.hassosakiAddressId = null
              self.rec.mstSeikyusaki.renrakusakiAddressId = null
              self.rec.mstNyukinsaki.mstTorihikisakiId = null
              self.rec.mstNyukinsaki.renrakusakiAddressId = null
              self.rec.mstShiiresaki.mstTorihikisakiId = null
              self.rec.mstShiiresaki.mstKingakuId = null
              self.rec.mstHacchusaki.mstTorihikisakiId = null
              self.rec.mstHacchusaki.mstKingakuId = null
              self.rec.mstShiharaisaki.mstTorihikisakiId = null
              self.rec.mstShiharaisaki.hassosakiAddressId = null
              self.rec.mstShiharaisaki.renrakusakiAddressId = null
            }
            resolve()
          })
        }
      }

      this.cancelInputs(opt)
    },
    onDeleteButtonClick: function (e) {
      const self = this
      const opt = {
        deleteRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post(`/api/v1/MstTorihikisaki/DeleteMulti?id=${self.id}`, self.rec).then(data => {
              resolve(data)
            })
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        }
      }
      this.delete(opt)
    },
    onCopyButtonClick: function (e) {
      const self = this
      const opt = {
        setIdMethod: () => {
          self.id = 0
          self.rec.mstTorihikisaki.id = 0
          self.rec.mstTorihikisaki.kihonAddressId = null
          self.rec.mstTorihikisaki.addAddressId1 = null
          self.rec.mstTorihikisaki.addAddressId2 = null
          self.rec.mstTokuisaki.mstTorihikisakiId = null
          self.rec.mstTokuisaki.mstKingakuId = null
          self.rec.mstSeikyusaki.mstTorihikisakiId = null
          self.rec.mstSeikyusaki.hassosakiAddressId = null
          self.rec.mstSeikyusaki.renrakusakiAddressId = null
          self.rec.mstNyukinsaki.mstTorihikisakiId = null
          self.rec.mstNyukinsaki.renrakusakiAddressId = null
          self.rec.mstShiiresaki.mstTorihikisakiId = null
          self.rec.mstShiiresaki.mstKingakuId = null
          self.rec.mstHacchusaki.mstTorihikisakiId = null
          self.rec.mstHacchusaki.mstKingakuId = null
          self.rec.mstShiharaisaki.mstTorihikisakiId = null
          self.rec.mstShiharaisaki.hassosakiAddressId = null
          self.rec.mstShiharaisaki.renrakusakiAddressId = null
          self.rec.mstHacchusakiEigyosho = null
          self.modeOfEdit = 0
          self.copyMode = true
        }
      }
      this.copyInputs(opt)
    },
    onSaveButtonClick: function (e) {
      const self = this
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.id = data.payload.id
            console.log('registerResponsePromise', self.id)
            self.copyMode = false
            resolve()
          })
        },
        judgeKeyChangedMethod: (data) => {
          return data.rec.mstTorihikisaki.torihikisakiCd !== this.rec.mstTorihikisaki.torihikisakiCd
        },
        getIdMethod: () => {
          console.log('getIdMethod', self.id)
          return self.id
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            console.log('continuousInputInitializePromise', id)
            console.log(JSON.stringify({ id: id }))
            self.id = id
            self.transition(1, { id: id }, self.initialize)
          })
        },
        getTransitionBackParams: function () {
          console.log('getTransitionBackParams', self.id)
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        isUpdateModeMethod: function () {
          console.log('isUpdateModeMethod', self.id)
          return self.id !== 0
        },
        getSavedInputMethod: function () {
          console.log('★getSavedInputMethod★')
          return {
            seikyuKeisanRuleKbn: self.rec.mstTorihikisaki.seikyuKeisanRuleKbn,
            shiireKeisanRuleKbn: self.rec.mstTorihikisaki.shiireKeisanRuleKbn,
            hacchuKeisanRuleKbn: self.rec.mstTorihikisaki.hacchuKeisanRuleKbn,
            seikyuTogetsuKijunHandanKbn: self.seikyuTogetsuKijunHandanKbn,
            seikyuTaxHasuKeisanKbn: self.rec.mstSeikyusaki.taxHasuKeisanKbn,
            seikyuTaxKeisanUnitKbn: self.rec.mstSeikyusaki.taxKeisanUnitKbn,
            seikyushoShiharaiOutputFlg: self.rec.mstSeikyusaki.seikyushoShiharaiOutputFlg,
            seikyushoKaishaNmOutputFlg: self.rec.mstSeikyusaki.seikyushoKaishaNmOutputFlg,
            // otherSeikyushoHassosakiFlg: self.otherSeikyushoHassosakiFlg,
            // otherSeikyushoRenrakusakiFlg: self.otherSeikyushoRenrakusakiFlg,
            tokuiUnchinHasuKeisanKbn: self.rec.mstTokuisaki.unchinHasuKeisanKbn,
            tokuiUnchinKeisanKbn: self.rec.mstTokuisaki.unchinKeisanKbn,
            furikomiTesuryoFlg: self.rec.mstNyukinsaki.furikomiTesuryoFlg,
            // otherNyukinRenrakusakiFlg: self.otherNyukinRenrakusakiFlg,
            hacchusakiUnchinHasuKeisanKbn: self.rec.mstHacchusaki.unchinHasuKeisanKbn,
            hacchusakiUnchinKeisanKbn: self.rec.mstHacchusaki.unchinKeisanKbn,
            shiharaiTogetsuKijunHandanKbn: self.shiharaiTogetsuKijunHandanKbn,
            shiharaiTaxHasuKeisanKbn: self.rec.mstShiharaisaki.taxHasuKeisanKbn,
            shiharaiTaxKeisanUnitKbn: self.rec.mstShiharaisaki.taxKeisanUnitKbn,
            shiharaiShukkinmeisaiOutputFlg: self.rec.mstShiharaisaki.shiharaiShukkinmeisaiOutputFlg,
            shiharaiKaishaNmOutputFlg: self.rec.mstShiharaisaki.shiharaiKaishaNmOutputFlg
            // otherShiharaitsuchiHassosakiFlg: self.otherShiharaitsuchiHassosakiFlg,
            // otherShiharaitsuchiRenrakusakiFlg: self.otherShiharaitsuchiRenrakusakiFlg
          }
        }
      }

      this.register(opt)
    },
    registerPromise: function () {
      let f

      this.rec.mstTorihikisaki.tokuisakiFlg = this.tokuisakiFlg
      this.rec.mstTorihikisaki.shiiresakiFlg = this.shiiresakiFlg
      this.rec.mstTorihikisaki.hacchusakiFlg = this.hacchusakiFlg
      this.rec.hacchusakiSharyoKanriFlg = this.hacchusakiSharyoKanriFlg
      this.rec.mstTokuisaki.tokuisakiKobetsuSeikyumeisaishoFlg = this.tokuisakiKobetsuSeikyumeisaishoFlg
      if (!this.tokuisakiKobetsuSeikyumeisaishoFlg) {
        this.rec.mstTokuisaki.seikyumeisaishoLayoutKbn = ''
      }
      this.rec.mstShiiresaki.shiiresakiKobetsuShiharaimeisaishoFlg = this.shiiresakiKobetsuShiharaimeisaishoFlg
      if (!this.shiiresakiKobetsuShiharaimeisaishoFlg) {
        this.rec.mstShiiresaki.shiharaimeisaishoLayoutKbn = ''
      }
      this.rec.mstHacchusaki.hacchusakiKobetsuShiharaimeisaishoFlg = this.hacchusakiKobetsuShiharaimeisaishoFlg
      if (this.hacchusakiKobetsuShiharaimeisaishoFlg) {
        this.rec.mstHacchusaki.shiharaimeisaishoLayoutKbn = ''
      }

      if (this.tokuisakiFlg) {
        if (!this.ikkatsuSeikyusakiFlg) {
          this.rec.mstSeikyusaki.togetsuKijunHandanKbn = this.seikyuTogetsuKijunHandanKbn
          this.rec.mstTorihikisaki.seikyuTorihikisakiCd = this.rec.mstTorihikisaki.torihikisakiCd
          this.rec.mstTorihikisaki.seikyuKeisanRuleKbn = ''
        }
        if (!this.ikkatsuNyukinsakiFlg) {
          this.rec.mstTorihikisaki.nyukinTorihikisakiCd = this.rec.mstTorihikisaki.torihikisakiCd
          this.rec.mstTorihikisaki.nyukinKeisanRuleKbn = ''
        }
      } else {
        this.rec.mstTorihikisaki.seikyuTorihikisakiCd = ''
        this.rec.mstTorihikisaki.seikyuKeisanRuleKbn = ''
        this.rec.mstTorihikisaki.nyukinTorihikisakiCd = ''
        this.rec.mstTorihikisaki.nyukinKeisanRuleKbn = ''
      }

      if (this.shiiresakiFlg) {
        if (!this.ikkatsuShiharaisakiFlg) {
          this.rec.mstShiharaisaki.togetsuKijunHandanKbn = this.shiharaiTogetsuKijunHandanKbn
          this.rec.mstShiharaisaki.kozaSbt = this.shiharaiKozaSbt
          this.rec.mstTorihikisaki.shiireTorihikisakiCd = this.rec.mstTorihikisaki.torihikisakiCd
          this.rec.mstTorihikisaki.shiireKeisanRuleKbn = ''
        } else {
          this.rec.mstTorihikisaki.shiireTorihikisakiCd = this.shiharaiTorihikisakiCd
        }
      } else {
        this.rec.mstTorihikisaki.shiireTorihikisakiCd = ''
        this.rec.mstTorihikisaki.shiireKeisanRuleKbn = ''
      }

      if (this.hacchusakiFlg) {
        if (!this.ikkatsuShiharaisakiFlg) {
          this.rec.mstShiharaisaki.togetsuKijunHandanKbn = this.shiharaiTogetsuKijunHandanKbn
          this.rec.mstShiharaisaki.kozaSbt = this.shiharaiKozaSbt
          this.rec.mstTorihikisaki.hacchuTorihikisakiCd = this.rec.mstTorihikisaki.torihikisakiCd
          this.rec.mstTorihikisaki.hacchuKeisanRuleKbn = ''
        } else {
          this.rec.mstTorihikisaki.hacchuTorihikisakiCd = this.shiharaiTorihikisakiCd
        }
      } else {
        this.rec.mstTorihikisaki.hacchuTorihikisakiCd = ''
        this.rec.mstTorihikisaki.hacchuKeisanRuleKbn = ''
      }

      this.rec.address1UseFlg = this.address1UseFlg
      this.rec.address2UseFlg = this.address2UseFlg
      this.rec.otherSeikyushoHassosakiFlg = this.otherSeikyushoHassosakiFlg
      this.rec.seikyushoHassosakiKbn = this.seikyushoHassosakiKbn
      this.rec.otherSeikyushoRenrakusakiFlg = this.otherSeikyushoRenrakusakiFlg
      this.rec.seikyushoRenrakusakiKbn = this.seikyushoRenrakusakiKbn
      this.rec.otherNyukinRenrakusakiFlg = this.otherNyukinRenrakusakiFlg
      this.rec.nyukinRenrakusakiKbn = this.nyukinRenrakusakiKbn
      this.rec.otherShiharaitsuchiHassosakiFlg = this.otherShiharaitsuchiHassosakiFlg
      this.rec.shiharaitsuchiHassosakiKbn = this.shiharaitsuchiHassosakiKbn
      this.rec.otherShiharaitsuchiRenrakusakiFlg = this.otherShiharaitsuchiRenrakusakiFlg
      this.rec.shiharaitsuchiRenrakusakiKbn = this.shiharaitsuchiRenrakusakiKbn
      this.rec.ikkatsuSeikyusakiFlg = this.ikkatsuSeikyusakiFlg
      this.rec.ikkatsuNyukinsakiFlg = this.ikkatsuNyukinsakiFlg
      this.rec.ikkatsuShiharaisakiFlg = this.ikkatsuShiharaisakiFlg

      this.rec.torihikisakiKihonAddress.addressNm = this.rec.mstTorihikisaki.torihikisakiNm
      this.rec.torihikisakiKihonAddress.addressSeishikiNm = this.rec.mstTorihikisaki.torihikisakiSeishikiNm
      this.rec.torihikisakiAddAddress1.addressNm = this.add1AddressNm
      this.rec.torihikisakiAddAddress1.addressSeishikiNm = this.add1AddressSeishikiNm
      this.rec.torihikisakiAddAddress2.addressNm = this.add2AddressNm
      this.rec.torihikisakiAddAddress2.addressSeishikiNm = this.add2AddressSeishikiNm
      this.rec.seikyushoHassosakiAddress.addressNm = this.seikyuHassoAddressNm
      this.rec.seikyushoHassosakiAddress.addressSeishikiNm = this.seikyuHassoAddressSeishikiNm
      this.rec.seikyushoRenrakusakiAddress.addressNm = this.seikyuRenrakuAddressNm
      this.rec.seikyushoRenrakusakiAddress.addressSeishikiNm = this.seikyuRenrakuAddressSeishikiNm
      this.rec.nyukinRenrakusakiAddress.addressNm = this.nyukinRenrakuAddressNm
      this.rec.nyukinRenrakusakiAddress.addressSeishikiNm = this.nyukinRenrakuAddressSeishikiNm
      this.rec.shiharaitsuchiHassosakiAddress.addressNm = this.shiharaiHassoAddressNm
      this.rec.shiharaitsuchiHassosakiAddress.addressSeishikiNm = this.shiharaiHassoAddressSeishikiNm
      this.rec.shiharaitsuchiRenrakusakiAddress.addressNm = this.shiharaiRenrakuAddressNm
      this.rec.shiharaitsuchiRenrakusakiAddress.addressSeishikiNm = this.shiharaiRenrakuAddressSeishikiNm

      if (this.id === 0) {
        console.log('★登録処理')
        console.log('★rec', this.rec)
        f = this.HttpClient.post('/api/v1/MstTorihikisaki/CreateMulti', this.rec)
      } else {
        console.log('★更新処理')
        console.log('★rec', this.rec)
        f = this.HttpClient.put(`/api/v1/MstTorihikisaki/UpdateMulti?id=${this.id}`, this.rec)
      }
      return f
    },
    registerValidate: function () {
      console.log('validate start', this.cloneData)
      console.log('◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆', this.$refs)
      const msg = validators.compareDate(this.rec.mstTorihikisaki.tekiyoStartYmdString, this.rec.mstTorihikisaki.tekiyoEndYmdString)
      if (msg !== undefined) {
        console.log('tekiyoYmd')
        this.$refs.tekiyoStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.$refs.tekiyoEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        return false
      }
      if (this.address1UseFlg && (this.add1AddressSeishikiNm === undefined || this.add1AddressSeishikiNm === '')) {
        console.log('torihikisakiAddAddress1.addressSeishikiNm')
        this.$refs['torihikisakiAddAddress1.addressSeishikiNm'][this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001', ['正式名称']))
        this.setInvalidSummaryMessage('COME0001')
        return false
      }
      if (this.address1UseFlg && (this.add1AddressNm === undefined || this.add1AddressNm === '')) {
        console.log('torihikisakiAddAddress1.addressNm')
        this.$refs['torihikisakiAddAddress1.addressNm'][this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001', ['名称']))
        this.setInvalidSummaryMessage('COME0001')
        return false
      }
      if (this.address2UseFlg && (this.add2AddressSeishikiNm === undefined || this.add2AddressSeishikiNm === '')) {
        console.log('torihikisakiAddAddress2.addressSeishikiNm')
        this.$refs['torihikisakiAddAddress2.addressSeishikiNm'][this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001', ['正式名称']))
        this.setInvalidSummaryMessage('COME0001')
        return false
      }
      if (this.address2UseFlg && (this.add2AddressNm === undefined || this.add2AddressNm === '')) {
        console.log('torihikisakiAddAddress2.addressNm')
        this.$refs['torihikisakiAddAddress2.addressNm'][this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001', ['名称']))
        this.setInvalidSummaryMessage('COME0001')
        return false
      }
      if (this.tokuisakiFlg && this.ikkatsuSeikyusakiFlg) {
        console.log('mstTorihikisaki.seikyuTorihikisakiCd')
        if (this.rec.mstTorihikisaki.seikyuTorihikisakiCd === undefined || this.rec.mstTorihikisaki.seikyuTorihikisakiCd === '' || this.rec.mstTorihikisaki.seikyuTorihikisakiCd === null) {
          this.$refs.seikyuTorihikisakiCd[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001', ['一括請求先']))
          this.setInvalidSummaryMessage('COME0001')
          return false
        } else if (this.rec.mstTorihikisaki.seikyuTorihikisakiCd === this.rec.mstTorihikisaki.torihikisakiCd) {
          this.$refs.seikyuTorihikisakiCd[this.Ctrls.SET_INVALID_METHOD]('取引先基本情報と同じ取引先は不可')
          this.setInvalidSummaryMessage('COME0001')
          return false
        }
      }
      if (this.tokuisakiFlg && !this.ikkatsuSeikyusakiFlg) {
        if (this.rec.mstSeikyusaki.shimeDay === undefined || this.rec.mstSeikyusaki.shimeDay === '') {
          console.log('mstSeikyusaki.shimeDay')
          this.$refs['mstSeikyusaki.shimeDay'][this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001', ['締日']))
          this.setInvalidSummaryMessage('COME0001')
          return false
        } else if ((this.rec.mstSeikyusaki.shimeDay < 1 || this.rec.mstSeikyusaki.shimeDay > 31) && Number(this.rec.mstSeikyusaki.shimeDay) !== 99) {
          console.log('mstSeikyusaki.shimeDay')
          this.$refs['mstSeikyusaki.shimeDay'][this.Ctrls.SET_INVALID_METHOD](message.get('COMV0015', ['締日']))
          this.setInvalidSummaryMessage('COME0001')
          return false
        }
      }
      if (this.tokuisakiFlg && !this.ikkatsuSeikyusakiFlg && (this.rec.mstSeikyusaki.saito === undefined || this.rec.mstSeikyusaki.saito === '')) {
        console.log('mstSeikyusaki.saito')
        this.$refs['mstSeikyusaki.saito'][this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001', ['サイト']))
        this.setInvalidSummaryMessage('COME0001')
        return false
      }
      if (this.tokuisakiFlg && !this.ikkatsuSeikyusakiFlg) {
        if (this.rec.mstSeikyusaki.nyukinDay === undefined || this.rec.mstSeikyusaki.nyukinDay === '') {
          console.log('nyukinDay')
          this.$refs['mstSeikyusaki.nyukinDay'][this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001', ['入金日']))
          this.setInvalidSummaryMessage('COME0001')
          return false
        } else if ((this.rec.mstSeikyusaki.nyukinDay < 1 || this.rec.mstSeikyusaki.nyukinDay > 31) && Number(this.rec.mstSeikyusaki.nyukinDay) !== 99) {
          console.log('nyukinDay')
          this.$refs['mstSeikyusaki.nyukinDay'][this.Ctrls.SET_INVALID_METHOD](message.get('COMV0015', ['入金日']))
          this.setInvalidSummaryMessage('COME0001')
          return false
        }
      }
      if (this.tokuisakiFlg && !this.ikkatsuSeikyusakiFlg && this.rec.mstSeikyusaki.nyukinKbn === undefined) {
        console.log('nyukinKbn')
        this.$refs['mstSeikyusaki.nyukinKbn'][this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001', ['入金区分']))
        this.setInvalidSummaryMessage('COME0001')
        return false
      }
      if (this.tokuisakiFlg && !this.ikkatsuSeikyusakiFlg && this.rec.mstSeikyusaki.taxHasuKeisanKbn === undefined) {
        console.log('mstSeikyusaki.taxHasuKeisanKbn')
        this.$refs['mstSeikyusaki.taxHasuKeisanKbn'][this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001', ['消費税端数計算区分']))
        this.setInvalidSummaryMessage('COME0001')
        return false
      }
      if (this.tokuisakiFlg && !this.ikkatsuSeikyusakiFlg && this.rec.mstSeikyusaki.taxKeisanUnitKbn === undefined) {
        console.log('mstSeikyusaki.taxKeisanUnitKbn')
        this.$refs['mstSeikyusaki.taxKeisanUnitKbn'][this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001', ['消費税計算単位区分']))
        this.setInvalidSummaryMessage('COME0001')
        return false
      }
      if (this.tokuisakiFlg && !this.ikkatsuSeikyusakiFlg && this.otherSeikyushoHassosakiFlg && (this.seikyuHassoAddressSeishikiNm === undefined || this.seikyuHassoAddressSeishikiNm === '')) {
        console.log('seikyushoHassosakiAddress.addressSeishikiNm')
        this.$refs['seikyushoHassosakiAddress.addressSeishikiNm'][this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001', ['正式名称']))
        this.setInvalidSummaryMessage('COME0001')
        return false
      }
      if (this.tokuisakiFlg && !this.ikkatsuSeikyusakiFlg && this.otherSeikyushoHassosakiFlg && (this.seikyuHassoAddressNm === undefined || this.seikyuHassoAddressNm === '')) {
        console.log('seikyushoHassosakiAddress.addressNm')
        this.$refs['seikyushoHassosakiAddress.addressNm'][this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001', ['名称']))
        this.setInvalidSummaryMessage('COME0001')
        return false
      }
      if (this.tokuisakiFlg && !this.ikkatsuSeikyusakiFlg && this.otherSeikyushoRenrakusakiFlg && (this.seikyuRenrakuAddressSeishikiNm === undefined || this.seikyuRenrakuAddressSeishikiNm === '')) {
        console.log('seikyushoRenrakusakiAddress.addressSeishikiNm')
        this.$refs['seikyushoRenrakusakiAddress.addressSeishikiNm'][this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001', ['正式名称']))
        this.setInvalidSummaryMessage('COME0001')
        return false
      }
      if (this.tokuisakiFlg && !this.ikkatsuSeikyusakiFlg && this.otherSeikyushoRenrakusakiFlg && (this.seikyuRenrakuAddressNm === undefined || this.seikyuRenrakuAddressNm === '')) {
        console.log('seikyushoRenrakusakiAddress.addressNm')
        this.$refs['seikyushoRenrakusakiAddress.addressNm'][this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001', ['名称']))
        this.setInvalidSummaryMessage('COME0001')
        return false
      }
      if (this.tokuisakiFlg && [undefined, null, ''].includes(this.rec.mstTokuisaki.unchinHasuKeisanKbn)) {
        console.log('mstTokuisaki.unchinHasuKeisanKbn')
        this.$refs['mstTokuisaki.unchinHasuKeisanKbn'][this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001', ['運賃端数計算区分']))
        this.setInvalidSummaryMessage('COME0001')
        return false
      }
      if (this.tokuisakiFlg && [undefined, null, ''].includes(this.rec.mstTokuisaki.keijobiKbn)) {
        console.log('keijobiKbn')
        this.$refs['mstTokuisaki.keijobiKbn'][this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001', ['計上日区分']))
        this.setInvalidSummaryMessage('COME0001')
        return false
      }
      if (this.tokuisakiFlg && [undefined, null, ''].includes(this.rec.mstTokuisaki.suryoKeijoKbn)) {
        console.log('suryoKeijoKbn')
        this.$refs['mstTokuisaki.suryoKeijoKbn'][this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001', ['数量計上日区分']))
        this.setInvalidSummaryMessage('COME0001')
        return false
      }
      if (this.tokuisakiFlg && this.ikkatsuNyukinsakiFlg) {
        if ([undefined, null, ''].includes(this.rec.mstTorihikisaki.nyukinTorihikisakiCd)) {
          console.log('nyukinTorihikisakiCd')
          this.$refs.nyukinTorihikisakiCd[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001', ['一括入金先']))
          this.setInvalidSummaryMessage('COME0001')
          return false
        } else if (this.rec.mstTorihikisaki.nyukinTorihikisakiCd === this.rec.mstTorihikisaki.torihikisakiCd) {
          console.log('nyukinTorihikisakiCd')
          this.$refs.nyukinTorihikisakiCd[this.Ctrls.SET_INVALID_METHOD]('取引先基本情報と同じ取引先は不可')
          this.setInvalidSummaryMessage('COME0001')
          return false
        }
      }
      if (this.tokuisakiFlg && !this.ikkatsuNyukinsakiFlg && this.otherNyukinRenrakusakiFlg && (this.nyukinRenrakuAddressSeishikiNm === undefined || this.nyukinRenrakuAddressSeishikiNm === '')) {
        console.log('nyukinRenrakusakiAddress.addressSeishikiNm')
        this.$refs['nyukinRenrakusakiAddress.addressSeishikiNm'][this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001', ['正式名称']))
        this.setInvalidSummaryMessage('COME0001')
        return false
      }
      if (this.tokuisakiFlg && !this.ikkatsuNyukinsakiFlg && this.otherNyukinRenrakusakiFlg && (this.nyukinRenrakuAddressNm === undefined || this.nyukinRenrakuAddressNm === '')) {
        console.log('nyukinRenrakusakiAddress.addressNm')
        this.$refs['nyukinRenrakusakiAddress.addressNm'][this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001', ['名称']))
        this.setInvalidSummaryMessage('COME0001')
        return false
      }
      if (this.hacchusakiFlg && this.rec.mstHacchusaki.unchinHasuKeisanKbn === undefined) {
        console.log('mstTokuisaki.unchinHasuKeisanKbn')
        this.$refs['mstHacchusaki.unchinHasuKeisanKbn'][this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001', ['運賃端数計算区分']))
        this.setInvalidSummaryMessage('COME0001')
        return false
      }
      if ((this.shiiresakiFlg || this.hacchusakiFlg) && this.ikkatsuShiharaisakiFlg) {
        if (this.shiharaiTorihikisakiCd === undefined || this.shiharaiTorihikisakiCd === '' || this.shiharaiTorihikisakiCd === null) {
          console.log('ikkatsuShiharaisakiFlg')
          this.$refs.shiharaiTorihikisakiCd[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001', ['一括支払先']))
          this.setInvalidSummaryMessage('COME0001')
          return false
        } else if (this.shiharaiTorihikisakiCd === this.rec.mstTorihikisaki.torihikisakiCd) {
          console.log('ikkatsuShiharaisakiFlg')
          this.$refs.shiharaiTorihikisakiCd[this.Ctrls.SET_INVALID_METHOD]('取引先基本情報と同じ取引先は不可')
          this.setInvalidSummaryMessage('COME0001')
          return false
        }
      }
      if ((this.shiiresakiFlg || this.hacchusakiFlg) && !this.ikkatsuShiharaisakiFlg) {
        if (this.rec.mstShiharaisaki.shimeDay === undefined || this.rec.mstShiharaisaki.shimeDay === '') {
          console.log('mstShiharaisaki.shimeDay')
          this.$refs['mstShiharaisaki.shimeDay'][this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001', ['締日']))
          this.setInvalidSummaryMessage('COME0001')
          return false
        } else if ((this.rec.mstShiharaisaki.shimeDay < 1 || this.rec.mstShiharaisaki.shimeDay > 31) && Number(this.rec.mstShiharaisaki.shimeDay) !== 99) {
          console.log('mstShiharaisaki.shimeDay')
          this.$refs['mstShiharaisaki.shimeDay'][this.Ctrls.SET_INVALID_METHOD](message.get('COMV0015', ['締日']))
          this.setInvalidSummaryMessage('COME0001')
          return false
        }
      }
      if ((this.shiiresakiFlg || this.hacchusakiFlg) && !this.ikkatsuShiharaisakiFlg && (this.rec.mstShiharaisaki.saito === undefined || this.rec.mstShiharaisaki.saito === '' || this.rec.mstShiharaisaki.saito === null)) {
        console.log('mstShiharaisaki.saito')
        this.$refs['mstShiharaisaki.saito'][this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001', ['サイト']))
        this.setInvalidSummaryMessage('COME0001')
        return false
      }
      if ((this.shiiresakiFlg || this.hacchusakiFlg) && !this.ikkatsuShiharaisakiFlg) {
        if (this.rec.mstShiharaisaki.shiharaiDay === undefined || this.rec.mstShiharaisaki.shiharaiDay === '') {
          console.log('mstShiharaisaki.shiharaiDay')
          this.$refs['mstShiharaisaki.shiharaiDay'][this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001', ['支払日']))
          this.setInvalidSummaryMessage('COME0001')
          return false
        } else if ((this.rec.mstShiharaisaki.shiharaiDay < 1 || this.rec.mstShiharaisaki.shiharaiDay > 31) && Number(this.rec.mstShiharaisaki.shiharaiDay) !== 99) {
          console.log('mstShiharaisaki.shiharaiDay')
          this.$refs['mstShiharaisaki.shiharaiDay'][this.Ctrls.SET_INVALID_METHOD](message.get('COMV0015', ['支払日']))
          this.setInvalidSummaryMessage('COME0001')
          return false
        }
      }
      if ((this.shiiresakiFlg || this.hacchusakiFlg) && !this.ikkatsuShiharaisakiFlg && (this.rec.mstShiharaisaki.shiharaiKbn === undefined || this.rec.mstShiharaisaki.shiharaiKbn === '' || this.rec.mstShiharaisaki.shiharaiKbn === null)) {
        console.log('shiharaiKbn')
        this.$refs['mstShiharaisaki.shiharaiKbn'][this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001', ['支払方法区分']))
        this.setInvalidSummaryMessage('COME0001')
        return false
      }
      if ((this.shiiresakiFlg || this.hacchusakiFlg) && !this.ikkatsuShiharaisakiFlg && this.rec.mstShiharaisaki.taxHasuKeisanKbn === undefined) {
        console.log('mstShiharaisaki.taxHasuKeisanKbn')
        this.$refs['mstShiharaisaki.taxHasuKeisanKbn'][this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001', ['消費税端数計算区分']))
        this.setInvalidSummaryMessage('COME0001')
        return false
      }
      if ((this.shiiresakiFlg || this.hacchusakiFlg) && !this.ikkatsuShiharaisakiFlg && this.rec.mstShiharaisaki.taxKeisanUnitKbn === undefined) {
        console.log('mstShiharaisaki.taxKeisanUnitKbn')
        this.$refs['mstShiharaisaki.taxKeisanUnitKbn'][this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001', ['消費税計算単位区分']))
        this.setInvalidSummaryMessage('COME0001')
        return false
      }
      if ((this.shiiresakiFlg || this.hacchusakiFlg) && !this.ikkatsuShiharaisakiFlg && this.otherShiharaitsuchiHassosakiFlg && (this.shiharaiHassoAddressSeishikiNm === undefined || this.shiharaiHassoAddressSeishikiNm === '')) {
        console.log('shiharaitsuchiHassosakiAddress.addressSeishikiNm')
        this.$refs['shiharaitsuchiHassosakiAddress.addressSeishikiNm'][this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001', ['正式名称']))
        this.setInvalidSummaryMessage('COME0001')
        return false
      }
      if ((this.shiiresakiFlg || this.hacchusakiFlg) && !this.ikkatsuShiharaisakiFlg && this.otherShiharaitsuchiHassosakiFlg && (this.shiharaiHassoAddressNm === undefined || this.shiharaiHassoAddressNm === '')) {
        console.log('shiharaitsuchiHassosakiAddress.addressNm')
        this.$refs['shiharaitsuchiHassosakiAddress.addressNm'][this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001', ['名称']))
        this.setInvalidSummaryMessage('COME0001')
        return false
      }
      if ((this.shiiresakiFlg || this.hacchusakiFlg) && !this.ikkatsuShiharaisakiFlg && this.otherShiharaitsuchiRenrakusakiFlg && (this.shiharaiRenrakuAddressSeishikiNm === undefined || this.shiharaiRenrakuAddressSeishikiNm === '')) {
        console.log('shiharaitsuchiRenrakusakiAddress.addressSeishikiNm')
        this.$refs['shiharaitsuchiRenrakusakiAddress.addressSeishikiNm'][this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001', ['正式名称']))
        this.setInvalidSummaryMessage('COME0001')
        return false
      }
      if ((this.shiiresakiFlg || this.hacchusakiFlg) && !this.ikkatsuShiharaisakiFlg && this.otherShiharaitsuchiRenrakusakiFlg && (this.shiharaiRenrakuAddressNm === undefined || this.shiharaiRenrakuAddressNm === '')) {
        console.log('shiharaitsuchiRenrakusakiAddress.addressNm')
        this.$refs['shiharaitsuchiRenrakusakiAddress.addressNm'][this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001', ['名称']))
        this.setInvalidSummaryMessage('COME0001')
        return false
      }
      console.log('validate OK')
      return true
    },
    deleteValidate: function () {
      console.log('cloneData', this.cloneData)
      if (this.rec.mstTorihikisaki.torihikisakiCd !== this.cloneData.rec.mstTorihikisaki.torihikisakiCd) {
        this.$refs.torihikisakiCd[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0121', ['取引先コード']))
        this.setInvalidSummaryMessage('COME0015')
        return false
      }
      console.log('validate OK')
      return true
    }
  }
}
